// import React, {
//   useCallback,
//   useContext,
//   useEffect,
//   useRef,
//   useState
// } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import Webcam from 'react-webcam'
// import moment from 'moment'
// import {
//   setAlertMessageSnackbarMessageSeverity,
//   setAlertMessageSnackbarMsg,
//   setAlertMessageSnackbarOpen
// } from '../store/feedback'

// import { useLocation, useNavigate } from 'react-router-dom'
// import './style.css'
// import './camera.css'
// import axios from 'axios'
// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle
// } from '@mui/material'
// import Frame from '../imagesicons/Frame.png'
// import carImage from './new-img.png'

// import { Modal } from 'antd'
// import FileContext from '../context/Context'
// import { SnackbarAlert } from '../custom-component/AlertMessage'
// import InspectionSteps from './InspectionSteps'
// import { Box, Typography, keyframes } from '@mui/material'
// import ImageProgressBar2 from './ImageProgressBar2'
// import CustomToastify from './custom-notified-msg/CustomToastify'
// import { set_image_upload_status } from '../store/image_upload'
// import { useFullscreen } from '../context/FullScreenContext'
// import CustomVideoToastify from './custom-notified-msg/CustomVideoToastify'
// import VideoTimer from '../video-module/video-timer/VideoTimer'
// import Photo_Video_Instruction from './photo_video_instruction/Photo_Video_Instruction'
// import { useParams } from 'react-router-dom'
// import { toast } from 'react-toastify'
// import 'react-toastify/dist/ReactToastify.css'
// import { ToastContainer } from 'react-toastify'

// const CameraModule2 = () => {
//   const dispatch = useDispatch()
//   const [open, setOpen] = useState(false)
//   const [videoCaptured, setVideoCaptured] = useState(false)
//   const { requestFullscreen, isFullscreen } = useFullscreen()
//   const [showInstructionPage, setShowInstructionPage] = useState(false)
//   const [dialogWidth, setDialogWidth] = useState('29vw')
//   const [dialogText, setDialogText] = useState('0.9rem')
//   const [btnType, setBtnType] = useState(true)
//   const timerRef = useRef(31) // Ref to store elapsed time
//   const intervalRef = useRef(null)
//   const data = localStorage.getItem('cattle num');

//   const [zoomLevel, setZoomLevel] = useState(1)
//   const isIOS = () => {
//     return (
//       /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
//       (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
//     )
//   }
//   const cameraContainerRef = useRef(null)
//   const reload = require("./Reload.png");
//   // const cameraOption = `${process.env.PUBLIC_URL}/inspection-images/camera-option.png`
//   const [capturedTime, setCapturedTime] = useState(null)
//   const [hasRetaken, setHasRetaken] = useState(false)
//   const [isModalVisible, setIsModalVisible] = useState(false)
//   let [bodyType, setBodyType] = useState('SUV')
//   const [isProgressVisible, setIsProgressVisible] = useState(true)

//   const [audioChunks, setAudioChunks] = useState([])
//   const [mediaRecorder, setMediaRecorder] = useState(null)
//   const [isRecording, setIsRecording] = useState(false)
//   const [image, setImage] = useState(null)
//   const webcamRef = useRef(null)
//   const [showImage, setShowImage] = useState(false)
//   const [imageCaptured, setImageCaptured] = useState(false)
//   const [showCamera, setShowCamera] = useState(false)
//   const [numberOfCameras, setNumberOfCameras] = useState(0)
//   const [activeDeviceId, setActiveDeviceId] = useState(null)
//   const [devices, setDevices] = useState([])
//   const [imageBuffer, setImageBuffer] = useState(null)
//   const [currentImageIndex, setCurrentImageIndex] = useState(0)
//   const [imageDimensions, setImageDimensions] = useState({
//     width: 0,
//     height: 0
//   })
//   const containerRef = useRef(null)
//   const navigate = useNavigate()

//   const {
//     setCapturedImages360,
//     setCapturedImageWindshield,
//     setCapturedChassisRC,
//     setCapturedRegNo,
//     setCapturedOdometer,
//     setCapturedTyres,
//     capturedInspectionImages,
//     setCapturedInspectionImages,
//     // setEngineVideo,
//     // engineVideo,
//     odometerVideo,
//     setOdometerVideo
//   } = useContext(FileContext)
//   const {  latitude, longitude } = useSelector(
//     state => state.imagesStore
//   )
// const { id } = useParams();
// const {auditID} = useParams();
//   const mediaRecorderRef = useRef(null)
//   const [capturing, setCapturing] = useState(false)
//   const [recordedChunks, setRecordedChunks] = useState([])
//   //stencils
//   let stencilFolder = null

//   // Get userId from localStorage
//   const insuranceUser = JSON.parse(localStorage.getItem('insuranceUser'))
//   const insuranceUserID = JSON.parse(localStorage.getItem('inspectionConfiguration'))
//   // console.log("125",insuranceUserID.userID);

//   const userId = insuranceUser?.userId || insuranceUserID?.userID
//   console.log('User ID:', userId)
//   const lowerBodyType = bodyType?.toLowerCase()

//   if (lowerBodyType === 'suv') {
//     stencilFolder = 'stencil-img-suv'
//   } else if (lowerBodyType === 'muv') {
//     stencilFolder = 'stencil-img-muv'
//   } else if (lowerBodyType.includes('hatch back')) {
//     stencilFolder = 'stencil-img-hatchback'
//   } else if (lowerBodyType.includes('sedan')) {
//     stencilFolder = 'stencil-img-sedan'
//   }
//   // console.log("125",lowerBodyType);
//   console.log('stencil folder', stencilFolder)

//   const [isIconVisible, setIsIconVisible] = useState(true)
//   const storedConfig = localStorage.getItem('inspectionConfiguration')

//   // Parse the stored JSON (handle null case with fallback)
//   const inspectionConfig = storedConfig
//     ? JSON.parse(storedConfig).inspection_config
//     : null
//   const cngConfig = storedConfig ? JSON.parse(storedConfig).opt_cng : null
//   console.log('cngConfig', cngConfig)
//   console.log('182', inspectionConfig, inspectionConfig?.selectedMode)
//   const modes = inspectionConfig?.selectedMode
//   const imagesToCapture = [
//     {
//       viewName: 'Face',
//       imageName: 'Face',
//       // imageStencils: car_back_side,
//       mode: 'photo',
//       id: 1
//     },
    
//     {
//       viewName: 'Deceased Body',
//       imageName: 'Deceased Body',
//       // imageStencils: car_back_side,
//       mode: 'photo',
//       id: 2
//     },
// { viewName: 'Ear Tag + Forehead', imageName: 'Ear Tag + Forehead', mode: 'photo', id: 3 },
//   { viewName: 'Muzzle 1', imageName: 'Muzzle 1', mode: 'photo', id: 4 },
//   { viewName: 'Muzzle 2', imageName: 'Muzzle 2', mode: 'photo', id: 5 },
//   { viewName: 'Muzzle 3', imageName: 'Muzzle 3', mode: 'photo', id: 6 },

//   ]

 
//   // 	? imagesToCapture.slice(0, 8)
 
//   // let mandatoryImages = []
//   // if (inspectionConfig) {
   
//   //   if (inspectionConfig.selectedItems?.includes('Face')) {
//   //     mandatoryImages.push(
//   //       imagesToCapture.find(image => image.imageName === 'Face')
//   //     )
//   //   }
//   //   if (inspectionConfig.selectedItems?.includes('Deceased Body')) {
//   //     mandatoryImages.push(
//   //       imagesToCapture.find(image => image.imageName === 'Deceased Body')
//   //     )
//   //   }
//   //   if (inspectionConfig.selectedItems?.includes('Right Side')) {
//   //     mandatoryImages.push(
//   //       imagesToCapture.find(image => image.imageName === 'right_side')
//   //     )
//   //   }
//   //   if (inspectionConfig.selectedItems?.includes('Selfie with the car')) {
//   //     mandatoryImages.push(
//   //       imagesToCapture.find(image => image.imageName === 'selfie')
//   //     )
//   //   } 
//   // } else {
//   //   console.log('Config is null,setting default 20 images!')
//   //   mandatoryImages = imagesToCapture.filter(
//   //     image => image.id !== 10 && image.id !== 16 && image.id !== 23
//   //   )
//   // }
  
//   // // Fallback: if mandatoryImages is empty, use default images
//   // if (mandatoryImages.length === 0) {
//   //   console.log('mandatoryImages is empty, using default images')
//   //   mandatoryImages = imagesToCapture.filter(
//   //     image => image.id !== 10 && image.id !== 16 && image.id !== 23
//   //   )
//   // }
//   let mandatoryImages = [];

// if (inspectionConfig) {
//   const selected = inspectionConfig.selectedItems || [];

//   const pushByName = (name) => {
//     const img = imagesToCapture.find(
//       (x) => x.imageName === name || x.viewName === name
//     );
//     if (img) mandatoryImages.push(img);
//   };

//   if (selected.includes('Face')) pushByName('Face');
//   if (selected.includes('Deceased Body')) pushByName('Deceased Body');
//   if (selected.includes('Ear Tag + Forehead')) pushByName('Ear Tag + Forehead');
//   if (selected.includes('Muzzle 1')) pushByName('Muzzle 1');
//   if (selected.includes('Muzzle 2')) pushByName('Muzzle 2');
//   if (selected.includes('Muzzle 3')) pushByName('Muzzle 3');

// } else {
//   console.log('Config is null, setting default images!');
//   mandatoryImages = [...imagesToCapture];
// }

// // fallback
// if (mandatoryImages.length === 0) {
//   mandatoryImages = [...imagesToCapture];
// }

//   console.log('mandatoryImages', mandatoryImages)

//   // Sort based on the original order in imagesToCapture
//   mandatoryImages.sort((a, b) => {
//     return (
//       imagesToCapture.findIndex(img => img.imageName === a.imageName) -
//       imagesToCapture.findIndex(img => img.imageName === b.imageName)
//     )
//   })
//   console.log('Sorted mandatoryImages', mandatoryImages)

//   const [suggestion, setSuggestion] = useState('')
//   const [perfectImage, setPerfectImage] = useState(false)
//   const [currentImageTitle, setCurrentImageTitle] = useState(mandatoryImages[0] || null)
//   const [changed, setChanged] = useState('USR_542794')
  
//   // Ensure currentImageTitle is set when mandatoryImages is populated
//   useEffect(() => {
//     if (mandatoryImages.length > 0 && (!currentImageTitle || !currentImageTitle?.viewName)) {
//       setCurrentImageTitle(mandatoryImages[0])
//     }
//   }, [mandatoryImages.length])


//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const blobName = `cattle_insurance_details/${id}.json`;

//         // Step 1: Check if file exists and get signed URL from backend
//         const checkResponse = await fetch('/process_data/check_document_exists_others', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ blobName })
//         });

//         const checkData = await checkResponse.json();

//         if (checkData.exists && checkData.url) {
//           // Step 2: Fetch JSON from S3 via backend
//           const s3Response = await fetch('/process_data/get_s3_json', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ url: checkData.url })
//           });

//           const s3Data = await s3Response.json();

//           // Extract Make and Model
//           const make = s3Data?.data?.Make || '';
//           const model = s3Data?.data?.Model || '';

//           // Step 3: Call body type API
//           const bodyTypeRes = await axios.post('/process_data/getBodyType', {
//             make,
//             model
//           });

//           if (bodyTypeRes.data) {
//             setBodyType(bodyTypeRes.data['vehicle_body_type_description']);
//           } else {
//             setBodyType('---');
//           }
//         } else {
//           console.warn(`File not found in S3: ${blobName}`);
//           setBodyType('---');
//         }
//       } catch (err) {
//         console.error('Error fetching audit details:', err);
//         setBodyType('---');
//       }
//     };

//     fetchData();
//   }, [id]);

//   const showModal = () => {
//     setIsModalVisible(true)
//   }


//   const recordedChunksRef = useRef([])

//   const handleRetakeForVideo = async () => {
//     try {
//       // Reset states
//       setVideoCaptured(false)
//       setRecordedChunks([])

//       // Stop existing MediaRecorder if active
//       if (mediaRecorderRef.current) {
//         mediaRecorderRef.current.stop()
//         mediaRecorderRef.current = null // Reset the recorder reference
//       }

//       // Stop the previous webcam stream properly
//       if (webcamRef.current?.video?.srcObject) {
//         webcamRef.current.video.srcObject
//           .getTracks()
//           .forEach(track => track.stop())
//       }

//       // Reinitialize webcam stream
//       const stream = await navigator.mediaDevices.getUserMedia({
//         video: {
//           width: 1920,
//           height: 1080,
//           facingMode: 'environment'
//         },
//         audio:
//           !!userId &&
//           userId !== 'UID101' &&
//           userId !== 'USR_291628' &&
//           userId !== 'USR_542794' // Enable audio only if userId is valid and not restricted
//       })

//       if (webcamRef.current?.video) {
//         webcamRef.current.video.srcObject = stream // Attach new stream
//       } else {
//         console.error('Failed to attach stream to video element.')
//         return
//       }

//       console.log('Webcam stream successfully reinitialized.')

//       // Wait for a moment to ensure the stream is available
//       await new Promise(resolve => setTimeout(resolve, 500))

//       // Prepare MediaRecorder
//       // const mimeType = isIOS() ? "video/mp4" : "video/webm";
//       let mimeType = ''

//       if (MediaRecorder.isTypeSupported('video/mp4;codecs=avc1')) {
//         mimeType = 'video/mp4;codecs=avc1'
//       } else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
//         mimeType = 'video/webm;codecs=vp9'
//       } else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp8')) {
//         mimeType = 'video/webm;codecs=vp8'
//       } else {
//         mimeType = 'video/webm'
//       }
//       const options = {
//         mimeType,
//         videoBitsPerSecond: 5000000,
//         audioBitsPerSecond: 256000
//       }

//       mediaRecorderRef.current = new MediaRecorder(stream, options)
//       mediaRecorderRef.current.addEventListener(
//         'dataavailable',
//         handleDataAvailable
//       )

//       // Start the recording process
//       mediaRecorderRef.current.start()
//       console.log('Video retake process started successfully.')
//     } catch (error) {
//       console.error('Error during video retake process:', error)
//     }
//   }

//   const handleDataAvailable = useCallback(
//     ({ data }) => {
//       console.log('Data available:', data, data.size)
//       if (data.size > 0) {
//         recordedChunksRef.current.push(data) // Store in the ref
//         setRecordedChunks(prev => [...prev, data]) // Update state

//         if (currentImageTitle?.imageName === 'rpm_meter_video') {
//           console.log('setting vdo')
//           setOdometerVideo(recordedChunksRef.current)
//         }

//         let res = {
//           file: recordedChunksRef.current,
//           name: currentImageTitle?.imageName,
//           clickedTime: capturedTime,
//           id: currentImageTitle?.id,
//           latitude: latitude,
//           longitude: longitude
//         }
//         setCapturedInspectionImages(prevImages => {
//           // Filter out any images with the same id as the new one
//           const filteredImages = prevImages.filter(image => image.id !== res.id)
//           console.log('560', filteredImages)

//           // Add the new image
//           return [...filteredImages, res]
//         })
//       }
//     },
//     [currentImageTitle]
//   )





//   const [isDisabled, setIsDisabled] = useState(false);

//   const handleStartCaptureClick = useCallback(() => {
//     // Disable button for 10 seconds
//     setIsDisabled(true);
//     setTimeout(() => {
//       setIsDisabled(false);
//     }, 10000);

//     // Toggle button type state
//     setBtnType(!btnType);

//     const videoElement = webcamRef.current.video;
//     const stream = videoElement?.srcObject;

//     if (!stream || stream.getVideoTracks().length === 0) {
//       console.error('No video tracks available in the stream.');
//       return;
//     }

//     // Disable audio for userId 
//     if (!userId || userId === 'UID101' || userId === 'USR_291628' || userId === 'USR_542794') {
//       const audioTracks = stream.getAudioTracks();
//       audioTracks.forEach(track => track.stop());
//       console.log("Audio disabled for user ID: UID101");
//     }

//     setCapturing(true);

//     clearInterval(intervalRef.current);
//     timerRef.current = 31;

//     let mimeType = "";
//     if (MediaRecorder.isTypeSupported("video/mp4;codecs=avc1")) {
//       mimeType = "video/mp4;codecs=avc1";
//     } else if (MediaRecorder.isTypeSupported("video/webm;codecs=vp9")) {
//       mimeType = "video/webm;codecs=vp9";
//     } else if (MediaRecorder.isTypeSupported("video/webm;codecs=vp8")) {
//       mimeType = "video/webm;codecs=vp8";
//     } else {
//       mimeType = "video/webm";
//     }

//     const options = {
//       mimeType: mimeType,
//       videoBitsPerSecond: 5000000,
//       audioBitsPerSecond: 256000,
//     };

//     if (!userId || userId === 'UID101' || userId === 'USR_291628' || userId === 'USR_542794') {
//       delete options.audioBitsPerSecond;
//     }

//     try {
//       mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, options);
//       mediaRecorderRef.current.addEventListener('dataavailable', handleDataAvailable);

//       intervalRef.current = setInterval(() => {
//         if (timerRef.current > 0) {
//           timerRef.current -= 1;
//           setCapturing(prev => !prev);
//         }
//       }, 1000);

//       mediaRecorderRef.current.start();

//     } catch (error) {
//       console.error("Error starting the MediaRecorder:", error);
//     }
//   }, [webcamRef, setCapturing, mediaRecorderRef, handleDataAvailable, btnType]);
//   useEffect(() => {
//     if (timerRef.current <= 0) {
//       handleStopCaptureClick() // Stop capture when timer hits 0
//     }
//   }, [capturing]) // Listen for changes in capturing state

//   const handleStopCaptureClick = useCallback(async () => {
//     setBtnType(!btnType)
//     setVideoCaptured(!videoCaptured)
//     console.log('stop')
//     mediaRecorderRef.current.stop()

//     setCapturing(false)
//     clearInterval(intervalRef.current)
//     timerRef.current = 31
//     console.log(recordedChunks, '183')
//   }, [btnType])

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth <= 400) {
//         setDialogWidth('85vw')
//       } else if (window.innerWidth <= 475) {
//         setDialogWidth('74vw')
//       } else if (window.innerWidth <= 550) {
//       } else if (window.innerWidth <= 575) {
//         setDialogText('0.6rem')
//         setDialogWidth('64vw')
//       } else if (window.innerWidth <= 650) {
//         setDialogWidth('60vw')
//       } else if (window.innerWidth <= 775) {
//         setDialogWidth('57vw')
//       } else if (window.innerWidth <= 875) {
//         setDialogWidth('55vw')
//       } else if (window.innerWidth <= 1000) {
//         setDialogWidth('48vw')
//       } else if (window.innerWidth <= 1100) {
//         setDialogWidth('45vw')
//         setDialogText('0.8rem')
//       } else if (window.innerWidth <= 1300) {
//         setDialogWidth('40vw')
//       } else {
//         setDialogWidth('35vw')
//       }
//     }
//     handleResize()
//     window.addEventListener('resize', handleResize)
//     return () => {
//       window.removeEventListener('resize', handleResize)
//     }
//   }, [])

//   const analyzeLighting = imageData => {
//     //console.log(imageData, "9")
//     const { data, width, height } = imageData
//     let totalBrightness = 0

//     for (let i = 0; i < data.length; i += 4) {
//       const r = data[i]
//       const g = data[i + 1]
//       const b = data[i + 2]
//       const brightness = (r + g + b) / 3
//       totalBrightness += brightness
//     }
//     const averageBrightness = totalBrightness / (width * height)

//     if (averageBrightness < 100) {
//       return 'Increase lighting.'
//     } else if (averageBrightness > 200) {
//       return 'Reduce lighting.'
//     } else {
//       return 'Lighting looks good.'
//     }
//   }

//   const captureAndAnalyze = useCallback(() => {
//     if (webcamRef?.current && webcamRef.current?.getScreenshot()) {
//       const imageSrc = webcamRef.current.getScreenshot()
//       const image = new Image()
//       image.src = imageSrc

//       image.onload = () => {
//         const canvas = document.createElement('canvas')
//         const ctx = canvas.getContext('2d')
//         canvas.width = image.width
//         canvas.height = image.height
//         ctx.drawImage(image, 0, 0, image.width, image.height)

//         const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
//         const lightingSuggestion = analyzeLighting(imageData)
//         if (lightingSuggestion === 'Lighting looks good.') {
//           setPerfectImage(true)
//         } else {
//           setPerfectImage(false)
//         }
//         setSuggestion(lightingSuggestion)
//       }
//     }
//   }, [])

//   useEffect(() => {
//     // Periodically analyze lighting for the current frame
//     const interval = setInterval(captureAndAnalyze, 500)
//     return () => clearInterval(interval)
//   }, [captureAndAnalyze])

//   const azure_image_file_name = (id,data, image_name, file_name) => {
//     console.log(id, image_name, file_name,"1026")
//         return `${data}_${image_name}_${file_name}`

//     // return `${id}_${data}_${image_name}_${file_name}`
//   }

  

//   const upload_image_to_s3 = async (
//     auditID,
//     id,
//     clicked_time,
//     latitude,
//     longitude,
//     fileName,
//     base64String, // <-- base64 without prefix
//     image_name
//   ) => {
//     try {

//       axios.post("/aiProcessingApis/uploadToTopic", { "id": id, "auditID": auditID, "image_name": fileName, "imageCategory": image_name, "clicked_time": clicked_time, "latitude": latitude, "longitude": longitude });
//       if (!base64String || base64String.length < 1000) {
//         console.error('Invalid image data');
//         return;
//       }

//       // ✅ Convert Base64 to Blob
//       const byteCharacters = atob(base64String);
//       const byteNumbers = new Array(byteCharacters.length);
//       for (let i = 0; i < byteCharacters.length; i++) {
//         byteNumbers[i] = byteCharacters.charCodeAt(i);
//       }
//       const byteArray = new Uint8Array(byteNumbers);
//       const blob = new Blob([byteArray], { type: 'image/jpeg' });

//       // ✅ Create FormData
//       const formData = new FormData();
//       formData.append('blobName', `Cattle_Insurance_Inspection/auditImages/claimImages/${fileName}`);
//       formData.append('file', blob, fileName); // ✅ Proper Blob
//       formData.append('contentType', 'image/jpeg');

//       const response = await axios.post('/process_data/upload-img', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data'
//         },
//         maxContentLength: Infinity,
//         maxBodyLength: Infinity
//       });

//       if (response.status === 200) {
//         dispatch(set_image_upload_status({
//           image_name,
//           status: 1,
//           type: 's3_img_upload_status'
//         }));
//         console.log('✅ File uploaded successfully:', response.data.url);
//       }
//     } catch (error) {
//       console.error('Error uploading image:', error.message);
//     }
//   };




//   function base64ToBlob(base64, contentType = 'image/png') {
//     const byteCharacters = atob(base64);
//     const byteArrays = [];

//     for (let offset = 0; offset < byteCharacters.length; offset += 512) {
//       const slice = byteCharacters.slice(offset, offset + 512);
//       const byteNumbers = new Array(slice.length);
//       for (let i = 0; i < slice.length; i++) {
//         byteNumbers[i] = slice.charCodeAt(i);
//       }
//       const byteArray = new Uint8Array(byteNumbers);
//       byteArrays.push(byteArray);
//     }

//     return new Blob(byteArrays, { type: contentType });
//   }
  
//   const cacheImageBuffer = async (
//     fileName,
//     base64String,
//     clicked_time,
//     name,
//     type,
//     id,
//     latitude,
//     longitude
//   ) => {
//     try {
//       const cache = await caches.open('image-cache');
//       console.log("filename", fileName)

//       // ✅ Convert Base64 to Blob
//       const imageBlob = base64ToBlob(base64String, 'image/png');

//       const metadata = JSON.stringify({
//         clicked_time,
//         name,
//         type,
//         id,
//         latitude,
//         longitude
//       });

//       const cachedImageResponse = new Response(imageBlob, {
//         headers: { 'Content-Type': 'image/png' }
//       });

//       const cachedMetadataResponse = new Response(metadata, {
//         headers: { 'Content-Type': 'application/json' }
//       });

//       await cache.put(`${fileName}`, cachedImageResponse);
//       await cache.put(`${fileName}-metadata`, cachedMetadataResponse);

//       console.log(`Image and metadata cached successfully with key: ${fileName}`);
//     } catch (error) {
//       console.error('Failed to cache image and metadata:', error);
//     }
//   };

//   const handleFullscreenRequest = () => {
//     requestFullscreen()
//     setOpen(false)
//   }

//   const handleClose = event => {
//     if (
//       event.target.tagName.toLowerCase() !== 'button' &&
//       !event.target.closest('button')
//     ) {
//       // Prevent dialog from closing if click occurred outside of the button
//       return
//     }
//     setOpen(false)
//   }

//   const upload_images_data_db = async (
//     formData,
//     image_name,
//     maxRetries = 3
//   ) => {
//     let attempt = 0
//     console.log('fd', formData)

//     const tryUpload = () => {
//       axiosInstance
//         .post('/process_data/upload_process_storeclaim_individually', formData, {
//           headers: {
//             'Content-Type': 'multipart/form-data'
//           }
//         })
//         .then(response => {
//           if (response.status === 200) {
//             const res = {
//               image_name: image_name,
//               status: 1,
//               type: 'sql_upload_status'
//             }
//             dispatch(set_image_upload_status(res))
//           }
//           console.log('Successful', response.data)
//         })
//         .catch(error => {
//           attempt++
//           if (
//             attempt < maxRetries &&
//             (error.code === 'ECONNABORTED' ||
//               (error.response && error.response.status >= 500))
//           ) {
//             console.log(
//               `Attempt ${attempt} failed. Retrying in ${Math.pow(
//                 2,
//                 attempt
//               )} seconds...`
//             )
//             // setTimeout(tryUpload, Math.pow(2, attempt) * 1000);
//           } else {
//             console.error('Max retries reached or non-retryable error:', error)
//           }
//         })
//     }
//     tryUpload()
//   }
//   useEffect(() => {
//     const interval = setInterval(() => {
//       checkInactivityTimeout()
//     }, 60000) // check every 1 minute

//     return () => clearInterval(interval) // cleanup on unmount
//   }, [])
//   const checkInactivityTimeout = () => {
//     const now = Date.now()
//     const lastTimestamp = sessionStorage.getItem('lastPhotoTimestamp')

//     if (lastTimestamp && now - parseInt(lastTimestamp, 10) > 14 * 60 * 1000) {
//       sessionStorage.removeItem('lastPhotoTimestamp')
//       dispatch(
//         setAlertMessageSnackbarMsg(
//           '15-minute inactivity detected. Restarting inspection.'
//         )
//       )
//       dispatch(setAlertMessageSnackbarMessageSeverity('warning'))
//       dispatch(setAlertMessageSnackbarOpen(true))
//       navigate(-1)
//     }
//   }
//   const handleSave = () => {
//     const now = Date.now()
//     const lastTimestamp = sessionStorage.getItem('lastPhotoTimestamp')

//     if (lastTimestamp && now - parseInt(lastTimestamp, 10) > 14 * 60 * 1000) {
//       sessionStorage.removeItem('lastPhotoTimestamp')
//       dispatch(
//         setAlertMessageSnackbarMsg(
//           '15-minute inactivity detected. Restarting inspection.'
//         )
//       )
//       dispatch(setAlertMessageSnackbarMessageSeverity('warning'))
//       dispatch(setAlertMessageSnackbarOpen(true))
//       navigate(-1)
//       return
//     }
//     sessionStorage.setItem('lastPhotoTimestamp', now.toString())

//     if (!auditID) {
//       let alert = {
//         snackbarOpen: true,
//         snackbarMessage: 'Audit not found !',
//         snackbarMessageSeverity: 'error'
//       }
//       dispatch(
//         setAlertMessageSnackbarMessageSeverity(alert.snackbarMessageSeverity)
//       )
//       dispatch(setAlertMessageSnackbarMsg(alert.snackbarMessage))
//       dispatch(setAlertMessageSnackbarOpen(alert.snackbarOpen))
//       setTimeout(() => {
//         dispatch(setAlertMessageSnackbarOpen(false))
//       }, 5000)

//       navigate('/')
//     } else {
//       console.log('currentImageIndex-642', currentImageIndex)

//       const currentImage = mandatoryImages[currentImageIndex]
//       if (!currentImage) {
//         console.error('currentImage is undefined at index', currentImageIndex)
//         return
//       }
//       // const cur_img_id = currentImage.id >= 14 ? currentImage.id - 2 : currentImage.id;
//       console.log('currentImage', currentImage)

//       let res = {
//         file: image,
//         name: currentImage?.imageName,
//         clickedTime: capturedTime,
//         id: currentImage?.id,
//         latitude: latitude,
//         longitude: longitude
//       }
//       console.log('rest', res)
//       let activeId

//       if (
//         currentImage?.imageName === 'inner_windshield' ||
//         currentImage?.imageName === 'outer_windshield'
//       ) {
//         setCapturedImageWindshield(prevImages => [...prevImages, res])
//         activeId = '1'
//       } else if (currentImage?.imageName === 'registrationNo') {
//         setCapturedRegNo(prevImages => [...prevImages, res])
//         activeId = '1'
//       } else if (
//         currentImage?.imageName === 'chassis' ||
//         currentImage?.imageName === 'RC'
//       ) {
//         setCapturedChassisRC(prevImages => [...prevImages, res])
//         activeId = '1'
//       } else if (currentImage?.imageName === 'odometer') {
//         setCapturedOdometer(prevImages => [...prevImages, res])
//         activeId = '1'
//       } else if (
//         currentImage?.imageName === 'front_left_tyre' ||
//         currentImage?.imageName === 'back_left_tyre' ||
//         currentImage?.imageName === 'back_right_tyre' ||
//         currentImage?.imageName === 'front_right_tyre'
//       ) {
//         setCapturedTyres(prevImages => [...prevImages, res])
//         activeId = '1'
//       } else {
//         setCapturedImages360(prevImages => [...prevImages, res])
//         activeId = '0'
//       }
//       setCapturedInspectionImages(prevImages => {
//         // Filter out any images with the same id as the new one
//         const filteredImages = prevImages.filter(image => image.id !== res.id)

//         // Add the new image
//         return [...filteredImages, res]
//       })

//       try {
//         const fileName = azure_image_file_name(auditID,data, res.name, res.file.name)
//         const reader = new FileReader()
//         let buffer_curr

//         // const adjustedId = res.id > 18 && res.id <= 22 ? res.id - 1 : res.id
//        const adjustedId = res.id;

//         reader.onloadend = () => {
//           // buffer_curr = reader.result
//           const dataUrl = reader.result; // e.g., "data:image/jpeg;base64,/9j/..."
//           const base64String = dataUrl.split(',')[1]; // Remove prefix


//           cacheImageBuffer(
//             fileName,
//             base64String,
//             res.clickedTime,
//             res.name,
//             adjustedId,
//             auditID,
//             latitude,
//             longitude
//           )
//           // upload_image_to_azure(auditID, adjustedId, res.clickedTime, latitude, longitude, fileName, buffer_curr, res.name);
//           upload_image_to_s3(
//             auditID,
//             res.id,
//             res.clickedTime,
//             latitude,
//             longitude,
//             fileName,
//             base64String,
//             res.name
//           )

//           if (auditID) {
//             // const cattleSuffix = data?.match(/\d+$/)?.[0] || '';
//             // Combine auditID and suffix → "TL5X03142621_1"
//             // const cattleN = `${auditID}_${cattleSuffix}`;
//             const formData = new FormData()
//             formData.append('clickedTime', res.clickedTime)
//             formData.append('name', res.name)
//             formData.append('id', adjustedId)
//             formData.append('auditID', auditID)
//             formData.append('latitude', latitude)
//             formData.append('longitude', longitude)
//             formData.append('azure_image_name', fileName)
//            formData.append('cattlenumber', auditID)
           
            

//             upload_images_data_db(formData, res.name)
//           }
//         }

//         // reader.readAsArrayBuffer(image)
//         // ✅ Read file as Data URL for Base64
//         reader.readAsDataURL(image);
//       } catch (err) {
//         console.log(err)
//       }
//     }
//   }

//   const upload_vdo_data_db = async (formData, image_name, maxRetries = 3) => {
//     let attempt = 0
//     const tryUpload = async () => {
//       try {
//         console.log('1259')

//         const response = await axios.post(
//           '/process_data/upload_video_detail',
//           formData,
//           {
//             headers: { 'Content-Type': 'multipart/form-data' }
//           }
//         )
//         console.log('1262', response.data)

//         if (response.status === 200) {
//           dispatch(
//             set_image_upload_status({
//               image_name,
//               status: 1,
//               type: 'sql_upload_status'
//             })
//           )
//           console.log('Successful vdo data', response.data)
//         }
//       } catch (error) {
//         attempt++
//         if (
//           attempt < maxRetries &&
//           (error.code === 'ECONNABORTED' ||
//             (error.response && error.response.status >= 500))
//         ) {
//           console.log(
//             `Attempt ${attempt} failed. Retrying in ${Math.pow(
//               2,
//               attempt
//             )} seconds...`
//           )
//         } else {
//           console.error('Max retries reached or non-retryable error:', error)
//         }
//       }
//     }
//     tryUpload()
//   }

//   const handleSaveVideoDetails = () => {
//     if (!auditID) {
//       let alert = {
//         snackbarOpen: true,
//         snackbarMessage: 'Audit not found !',
//         snackbarMessageSeverity: 'error'
//       }
//       dispatch(
//         setAlertMessageSnackbarMessageSeverity(alert.snackbarMessageSeverity)
//       )
//       dispatch(setAlertMessageSnackbarMsg(alert.snackbarMessage))
//       dispatch(setAlertMessageSnackbarOpen(alert.snackbarOpen))
//       setTimeout(() => {
//         dispatch(setAlertMessageSnackbarOpen(false))
//       }, 5000)

//       navigate('/')
//     } else {
//       const currentImage = mandatoryImages[currentImageIndex]
//       if (!currentImage) {
//         console.error('currentImage is undefined at index', currentImageIndex)
//         return
//       }
//       const formattedCaptureTime = moment().format('YYYY-MM-DD HH:mm:ss')
//       let res = {
//         file: image,
//         name: currentImage?.imageName,
//         clickedTime: formattedCaptureTime,
//         id: currentImage?.id,
//         latitude: latitude,
//         longitude: longitude
//       }
//       const formData = new FormData()
//       formData.append('auditID', auditID)
//       formData.append('clickedTime', res.clickedTime)
//       upload_vdo_data_db(formData, 'video_detail')
//     }
//   }

//   useEffect(() => {
//     if ((imageCaptured || videoCaptured) && !hasRetaken) {
//       if (imageCaptured) {
//         handleSave() // Call handleSave immediately when imageCaptured is true
//       }
//       const timer = setTimeout(() => {
//         const currentImage = mandatoryImages[currentImageIndex]
//         if (currentImageIndex < mandatoryImages.length - 1) {
//           setCurrentImageIndex(currentImageIndex + 1)
//           setCurrentImageTitle(mandatoryImages[currentImageIndex + 1])
//           if (mandatoryImages[currentImageIndex + 1].viewName === 'Selfie') {
//             videoConstraintsRef.current = {
//               facingMode: 'user', // switch to front camera
//               width: 1920,
//               height: 1080
//             }
//           }
//           // setShowCamera(true);
//         }
//         setImageCaptured(false) // Update states after 6 seconds

//         if (videoCaptured) {
//           handleSaveVideoDetails()
//           setVideoCaptured(false)
//         }
//         if (currentImageIndex < mandatoryImages.length - 1) {
//           setShowInstructionPage(
//             mandatoryImages[currentImageIndex + 1].viewName ===
//             'RPM Meter Video'
//           )
//         }
//         setShowCamera(true)
//         // console.log("Updated states after 6 seconds");
//       }, 6000)

//       return () => clearTimeout(timer) // Clean up the timer
//     }
//   }, [hasRetaken, imageCaptured, videoCaptured])

//   useEffect(() => {
//     const handleBeforeUnload = event => {
//       const message = 'Are you sure you want to leave?'
//       event.returnValue = message
//       return message
//     }

//     window.addEventListener('beforeunload', handleBeforeUnload)

//     return () => {
//       window.removeEventListener('beforeunload', handleBeforeUnload)
//     }
//   }, [])

//   useEffect(() => {
//     if (!auditID) {
//       console.log('audit not present')
//       navigate('/')
//     }
//   }, [auditID])

//   useEffect(() => {
//     console.log('1223', capturedInspectionImages.length, mandatoryImages.length)
//     if (capturedInspectionImages.length === mandatoryImages.length) {
//       const timer = setTimeout(() => {
//         navigate(`/claimform/${auditID}`)

        
//         // navigate(`/processing/${auditID}`)
//       }, 6000) // Pass 6000 directly

//       return () => {
//         clearTimeout(timer) // Clear timeout on cleanup
//       }
//     }
//   }, [capturedInspectionImages, auditID, navigate])

//   useEffect(() => {
//     const handleBeforeUnload = event => {
//       const message = 'Are you sure you want to leave?'
//       event.returnValue = message
//       return message
//     }

//     const handlePopState = event => {
//       // console.log("back button");
//       if (window.confirm('Are you sure you want to navigate away?')) {
//         navigate('/')
//       }
//     }

//     const handleHashChange = event => {
//       if (window.confirm('Are you sure you want to navigate away?')) {
//       }
//     }

//     window.addEventListener('beforeunload', handleBeforeUnload)
//     window.addEventListener('popstate', handlePopState)
//     window.addEventListener('hashchange', handleHashChange)

//     return () => {
//       window.removeEventListener('beforeunload', handleBeforeUnload)
//       window.removeEventListener('popstate', handlePopState)
//       window.removeEventListener('hashchange', handleHashChange)
//     }
//   }, [])

//   const [windowDimensions, setWindowDimensions] = useState({
//     width: window.innerWidth,
//     height: window.innerHeight
//   })
// const setDimensions = () => {
//   const stencil = currentImageTitle?.imageStencils;

//   // ✅ guard
//   if (!stencil || typeof stencil !== "string") return;

//   const img = new Image();
//   img.src = stencil;

//   img.onload = () => {
//     const containerWidth = window.innerWidth;
//     const containerHeight = window.innerHeight;
//     const containerAspectRatio = containerWidth / containerHeight;
//     const imgAspectRatio = img.width / img.height;

//     let width, height;

//     if (imgAspectRatio > containerAspectRatio) {
//       width = containerWidth;
//       height = containerWidth / imgAspectRatio;
//     } else {
//       width = containerHeight * imgAspectRatio;
//       height = containerHeight;
//     }

//     setImageDimensions({ width, height });
//   };
// };

//   // const setDimensions = () => {
//   //   const img = new Image()
//   //   img.src = currentImageTitle?.imageStencils
//   //   img.onload = () => {
//   //     const containerWidth = window.innerWidth
//   //     const containerHeight = window.innerHeight
//   //     const containerAspectRatio = containerWidth / containerHeight
//   //     const imgAspectRatio = img.width / img.height

//   //     let width, height

//   //     if (imgAspectRatio > containerAspectRatio) {
//   //       width = containerWidth
//   //       height = containerWidth / imgAspectRatio
//   //     } else {
//   //       width = containerHeight * imgAspectRatio
//   //       height = containerHeight
//   //     }

//   //     setImageDimensions({ width, height })
//   //   }
//   // }

//   useEffect(() => {
//     setDimensions()
//     window.addEventListener('resize', setDimensions)
//     return () => {
//       window.removeEventListener('resize', setDimensions)
//     }
//   }, [currentImageTitle?.imageStencils])

//   useEffect(() => {
//     const handleResize = () => {
//       setWindowDimensions({
//         width: window.innerWidth,
//         height: window.innerHeight
//       })
//     }
//     window.addEventListener('resize', handleResize)
//     return () => window.removeEventListener('resize', handleResize)
//   }, [])

//   const handleRetakeClick = () => {
//     console.log('clicked retake')

//     // Set retake flag
//     setHasRetaken(true)

//     // Trigger recapture logic
//     handleRecapture()

//     // Remove the last saved image
//     setCapturedInspectionImages(prevImages => {
//       if (prevImages.length === 0) return [] // Handle edge case when the array is empty
//       return prevImages.slice(0, -1) // Remove the last image
//     })
//   }

//   const handleRecapture = () => {
//     setShowCamera(true)
//     setImageCaptured(false)
//     setHasRetaken(false)
//   }

//   const getDeviceType = () => {
//     const os = window.platform.os

//     if (os.family === 'iOS') {
//       return 'iPhone'
//     } else if (os.family === 'Android') {
//       return 'Android'
//     } else {
//       const isLaptop = window.innerWidth > 1024
//       return isLaptop ? 'Laptop' : 'Unknown Device'
//     }
//   }
//   const deviceType = getDeviceType()
//   let mutipier = 8
//   if (deviceType === 'Android') {
//     mutipier = 1
//   }

//   const handleDevices = React.useCallback(mediaDevices => {
//     const videoInputs = mediaDevices.filter(
//       device => device.kind === 'videoinput'
//     )

//     // Try to pick the Samsung "camera2 0, facing back" if available
//     const samsungBackCam = videoInputs.find(device =>
//       device.label.toLowerCase().includes('0')
//     )

//     // If on Samsung and we found the preferred back cam, use that
//     if (samsungBackCam) {
//       setActiveDeviceId(samsungBackCam.deviceId)
//     } else {
//       // Otherwise, fallback to any "facing back" cam
//       const genericBackCam = videoInputs.find(device =>
//         device.label.toLowerCase().includes('facing back')
//       )
//       setActiveDeviceId(null)
//     }
//   }, [])
//   useEffect(() => {
//     navigator.mediaDevices.enumerateDevices().then(handleDevices)
//   }, [handleDevices])

//   const videoConstraintsRef = useRef({
//     height: 1080,   // Portrait mode
//     width: 1920,  // Portrait mode
//     deviceId: activeDeviceId,
//     facingMode: 'environment'
//   })

//   useEffect(() => {
//   videoConstraintsRef.current = {
//     height: 1920,   // Portrait mode
//     width: 1080,  // Portrait mode
//     deviceId: activeDeviceId ? activeDeviceId : null,
//     facingMode: 'environment'
//   }
// }, [activeDeviceId])

//   const axiosInstance = axios.create({
//     timeout: 30000
//   })

//   const buttonStyle = {
//     display: 'flex',
//     cursor: 'pointer',
//     alignItems: 'center',
//     justifyContent: 'center',
//     width: '72px',
//     height: '72px',
//     backgroundColor: 'transparent',
//     borderRadius: '50%',
//     border: perfectImage ? '4px solid #4CAF50' : '4px solid white',
//     padding: '1px' // gap
//   }

//   const innerCircleStyle = {
//     width: '55px',
//     height: '55px',
//     backgroundColor: 'white',
//     borderRadius: '50%'
//   }

//   const capturePhoto = React.useCallback(() => {
//     const imageSrc = webcamRef.current.getScreenshot({
//       // width: videoConstraintsRef.current.width,
//       // height: videoConstraintsRef.current.height,
//       quality: 1
//     })
//     const formattedCaptureTime = moment().format('YYYY-MM-DD HH:mm:ss')

//     // const dataURLtoBlob = dataURL => {
//     //   const byteString = atob(dataURL.split(',')[1])
//     //   const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0]
//     //   const ab = new ArrayBuffer(byteString.length)
//     //   const ia = new Uint8Array(ab)
//     //   for (let i = 0; i < byteString.length; i++) {
//     //     ia[i] = byteString.charCodeAt(i)
//     //   }
//     //   return new Blob([ab], { type: mimeString })
//     // }
// const dataURLtoBlob = (dataURL) => {
//   if (!dataURL || typeof dataURL !== 'string') {
//     console.error('Invalid dataURL:', dataURL);
//     return null;
//   }

//   if (!dataURL.startsWith('data:')) {
//     console.error('Not a valid data URL:', dataURL);
//     return null;
//   }

//   const parts = dataURL.split(',');
//   if (parts.length < 2) {
//     console.error('Malformed data URL:', dataURL);
//     return null;
//   }

//   const byteString = atob(parts[1]);
//   const mimeString = parts[0].split(':')[1].split(';')[0];

//   const ab = new ArrayBuffer(byteString.length);
//   const ia = new Uint8Array(ab);

//   for (let i = 0; i < byteString.length; i++) {
//     ia[i] = byteString.charCodeAt(i);
//   }

//   return new Blob([ab], { type: mimeString });
// };
// if (!imageSrc) {
//   console.warn('imageSrc is null, skipping blob creation');
//   return;
// }
//     const blob = dataURLtoBlob(imageSrc)
//     if (!blob) return;

//     // console.log(imageSrc, "imageSrc")
//     const file = new File([blob], 'captured_image.jpeg', {
//       type: 'image/jpeg'
//     })

//     setImage(file)
//     setCapturedTime(formattedCaptureTime)
//     console.log('1634', file, formattedCaptureTime)

//     // Convert the file to an ArrayBuffer (Buffer)
//     const reader = new FileReader()
//     reader.onloadend = () => {
//       const buffer = reader.result
//       setImageBuffer(buffer)
//       // console.log(buffer); // You can now use the buffer
//       // Do something with the buffer if needed
//     }
//     reader.readAsArrayBuffer(file)
//     setImageCaptured(true)
//   }, [webcamRef])

//   const formatTime = seconds => {
//     const minutes = Math.floor(seconds / 60)
//     const remainingSeconds = seconds % 60
//     return `${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''
//       }${remainingSeconds}`
//   }

//   useEffect(() => {
//     const checkPermissions = () => {
//       navigator.permissions
//         .query({ name: 'camera' })
//         .then(permissionStatus => {
//           if (permissionStatus.state === 'granted') {
//           } else if (permissionStatus.state === 'prompt') {
//             // Prompt the user for camera permission
//             navigator.mediaDevices
//               .getUserMedia({ video: true })
//               .then(() => {
//                 console.log('Prompting for camera permissions')
//               })
//               .catch(error => {
//                 console.log('Error:', error)
//               })
//           } else {
//           }
//         })
//         .catch(error => console.log('Error:', error))
//     }
//     checkPermissions()
//   }, [])

//   useEffect(() => {
//     const applyZoom = async () => {
//       try {
//         const stream = webcamRef.current?.video?.srcObject
//         if (stream) {
//           const track = stream.getVideoTracks()[0]
//           const capabilities = track.getCapabilities()
//           if (capabilities.zoom) {
//             const settings = track.getSettings()
//             setZoomLevel(settings.zoom || 1)
//             await track.applyConstraints({
//               advanced: [{ zoom: 1.08 }]
//             })
//             setZoomLevel(1.0)
//           } else {
//             console.log('Zoom is not supported on this device.')
//           }
//         }
//       } catch (error) {
//         console.error('Error applying zoom level: ', error)
//       }
//     }

//     if (webcamRef.current) {
//       webcamRef.current.video.addEventListener('loadedmetadata', applyZoom)
//     }

//     return () => {
//       if (webcamRef.current) {
//         webcamRef.current.video.removeEventListener('loadedmetadata', applyZoom)
//       }
//     }
//   }, [webcamRef])

//   const stopAudioRecordingAndUpload = async (
//     auditID,
//     currentImageIndex,
//     imagesToCapture,
//     recorder
//   ) => {
//     if (recorder && recorder.state !== 'inactive') {
//       console.log('Stopping the audio recording...')

//       recorder.ondataavailable = async event => {
//         const audioBlob = event.data;
//         console.log('Audio data available.');

//         // Convert audioBlob to Base64
//         const base64Audio = await blobToBase64(audioBlob);

//         // Prepare payload
//         const payload = {
//           blobName: `Insurance_Inspection/auditAudios/${auditID}_audio.webm`, // keep naming convention
//           fileContent: base64Audio,
//           contentType: audioBlob.type || 'audio/webm'
//         };

//         // Send to backend
//         try {
//           const response = await fetch('/process_data/upload-file', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify(payload)
//           });

//           const result = await response.json();
//           if (response.ok) {
//             console.log('Audio uploaded successfully:', result.url);
//           } else {
//             console.error('Upload failed:', result.error);
//           }
//         } catch (error) {
//           console.error('Error uploading audio:', error);
//         }
//       };

//       recorder.stop(); // Stop the recording
//     }
//   };

//   // Helper function to convert Blob to Base64
//   const blobToBase64 = blob => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         const base64data = reader.result.split(',')[1]; // remove data:... prefix
//         resolve(base64data);
//       };
//       reader.onerror = reject;
//       reader.readAsDataURL(blob);
//     });
//   };


//   useEffect(() => {
//     const startAudioRecording = async () => {
//       try {
//         const stream = await navigator.mediaDevices.getUserMedia({
//           audio: true
//         })
//         const recorder = new MediaRecorder(stream)

//         recorder.ondataavailable = event => {
//           if (event.data.size > 0) {
//             setAudioChunks(prev => [...prev, event.data])
//           }
//         }

//         setMediaRecorder(recorder) // Set recorder instance
//         recorder.start() // Automatically start recording
//         setIsRecording(true)

//         console.log('Audio recording started.')
//       } catch (error) {
//         console.error('Error accessing audio stream: ', error)
//       }
//     }

//     // Conditionally start recording if userId is not 'UID101'
//     if (
//       userId &&
//       userId !== 'UID101' &&
//       userId !== 'USR_291628' &&
//       userId !== 'USR_542794'
//     ) {
//       startAudioRecording()
//     }

//     return () => {
//       if (mediaRecorder && mediaRecorder.state !== 'inactive') {
//         mediaRecorder.stop()
//         setIsRecording(false)
//       }
//     }
//   }, [])

//   useEffect(() => {
//     if (mandatoryImages.length === 0 || !mandatoryImages[currentImageIndex]) {
//       return
//     }
//     console.log('vn', mandatoryImages[currentImageIndex]?.viewName)
//     if (mandatoryImages[currentImageIndex]?.viewName === 'RPM Meter Video') {
//       console.log('1529 here!')
//       stopAudioRecordingAndUpload(
//         id,
//         currentImageIndex,
//         mandatoryImages,
//         mediaRecorder
//       )
//     }
//   }, [isRecording, imagesToCapture, currentImageIndex, mediaRecorder])

//   useEffect(() => {
//     // Reset the icon visibility whenever `currentImageTitle` changes
//     setIsIconVisible(true)

//     // Set a timer to hide the icon after 5 seconds
//     const timer = setTimeout(() => {
//       setIsIconVisible(false) // Hide the icon
//     }, 18000)

//     // Cleanup timer when the component unmounts or `currentImageTitle` changes
//     return () => clearTimeout(timer)
//   }, [currentImageTitle])
//   const [isNetworkPoor, setIsNetworkPoor] = useState(false)
//   // useEffect(() => {
//   //   console.log('img-id', mandatoryImages[currentImageIndex]?.id)

//   //   const checkNetwork = () => {
//   //     console.log('img-id-inside', mandatoryImages[currentImageIndex].id)

//   //     if (
//   //       mandatoryImages[currentImageIndex]?.id >= 15 &&
//   //       mandatoryImages[currentImageIndex]?.id < 18
//   //     ) {
//   //       console.log('checking net..')

//   //       if (navigator.connection) {
//   //         const { downlink, effectiveType } = navigator.connection
//   //         console.log('1571', downlink, effectiveType)

//   //         if (
//   //           downlink < 5 ||
//   //           effectiveType === '3g' ||
//   //           effectiveType === '2g'
//   //         ) {
//   //           setIsNetworkPoor(true)
//   //           toast.warn('Network is poor', {
//   //             position: 'bottom-right', // Set toast position
//   //             autoClose: 3000, // Close after 3 seconds
//   //             hideProgressBar: false,
//   //             closeOnClick: true,
//   //             pauseOnHover: false,
//   //             draggable: false,
//   //             theme: 'colored',
//   //             style: {
//   //               backgroundColor: '#FC350B',
//   //               color: '#fffff',
//   //               width: 'auto',
//   //               maxWidth: '300px', // Set a max limit
//   //               padding: '10px 20px' // Improve spacing ,
//   //             }
//   //           })
//   //         } else {
//   //           setIsNetworkPoor(false)
//   //         }
//   //       }
//   //     }
//   //   }

//   //   const interval = setInterval(checkNetwork, 30000) // Check every 30 seconds
//   //   return () => clearInterval(interval)
//   // }, [])

// useEffect(() => {
//   const checkNetwork = () => {
//     const cur = mandatoryImages[currentImageIndex];
//     if (!cur) return;

//     console.log("img-id", cur.id);

//     // keep your condition if you still need it
//     if (cur.id >= 15 && cur.id < 18) {
//       if (navigator.connection) {
//         const { downlink, effectiveType } = navigator.connection;

//         if (downlink < 5 || effectiveType === "3g" || effectiveType === "2g") {
//           setIsNetworkPoor(true);
//           toast.warn("Network is poor", {
//             position: "bottom-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: false,
//             draggable: false,
//             theme: "colored",
//             style: {
//               backgroundColor: "#FC350B",
//               color: "#fffff",
//               width: "auto",
//               maxWidth: "300px",
//               padding: "10px 20px",
//             },
//           });
//         } else {
//           setIsNetworkPoor(false);
//         }
//       }
//     }
//   };

//   checkNetwork(); // run once immediately
//   const interval = setInterval(checkNetwork, 30000);
//   return () => clearInterval(interval);
// }, [currentImageIndex, mandatoryImages]);
// const getInstructionText = (viewName) => {
//   const map = {
//     Face: "Take photo of the Face of the animal",
//     "Deceased Body": "Take photo of Deceased Body of the animal",
//     "Ear Tag + Forehead": "Take photo of eartag with the forehead of the animal",
//     "Muzzle 1": "Take photo of muzzle view 1 of the animal",
//     "Muzzle 2": "Take photo of muzzle view 2 of the animal",
//     "Muzzle 3": "Take photo of muzzle view 3 of the animal",
//   };

//   if (!viewName) return "Loading...";
//   return map[viewName] || `Take photo of the ${viewName.toLowerCase()} of the animal`;
// };

//   return (
//   <div ref={cameraContainerRef}>
//     <Dialog
//       open={open}
//       onClose={handleClose}
//       className='full_screen_class'
//       PaperProps={{
//         style: {
//           width: dialogWidth,
//           padding: '0.5rem 0.5rem',
//           paddingBottom: '0.5rem',
//           borderRadius: '4px',
//           margin: '0'
//         }
//       }}
//     >
//       <DialogContent sx={{ padding: '0.2rem 0.3rem' }}>
//         <DialogTitle
//           style={{
//             fontSize: dialogText,
//             color: 'black',
//             padding: '0.4rem 0',
//             fontWeight: '600'
//           }}
//         >
//           Full Screen Mode ?
//         </DialogTitle>
//         <DialogContentText sx={{ color: 'black', fontSize: '0.8rem' }}>
//           Switch to full screen mode.
//         </DialogContentText>
//       </DialogContent>
//       <DialogActions sx={{ padding: '0.4rem' }}>
//         <div
//           style={{
//             padding: '0.1rem'
//           }}
//         >
//           <button
//             onClick={handleFullscreenRequest}
//             style={{
//               color: 'white',
//               backgroundColor: '#FC350B',
//               border: 'none',
//               padding: '0.4rem 0.8rem',
//               textTransform: 'capitalize',
//               borderRadius: '20px',
//               cursor: 'pointer'
//             }}
//           >
//             Switch
//           </button>
//         </div>
//       </DialogActions>
//     </Dialog>
//     {showImage ? (
//       <div
//         style={{
//           width: '100%',
//           height: '100svh',
//           zIndex: 100,
//           position: 'absolute',
//           backgroundColor: 'black',
//           backgroundImage: image ? `url(${URL.createObjectURL(image)})` : '',
//           backgroundSize: 'contain',
//           backgroundRepeat: 'no-repeat',
//           backgroundPosition: 'center'
//         }}
//         onClick={() => setShowImage(!showImage)}
//       />
//     ) : (
//         <>
//           {showInstructionPage ? (
//             <Photo_Video_Instruction
//               setShowInstructionPage={setShowInstructionPage}
//             />
//           ) : (
//             <>
//               {/* CURRENT IMAGE TITLE */}
//               <Typography
//                 sx={{
//                   display: 'flex',
//                   flexDirection: 'column',
//                   justifyContent: 'center',
//                   alignItems: 'center',
//                   padding: '8px 8px',
//                   gap: '10px',
//                   position: 'absolute',
//                   width: 'auto',
//                   height: 'auto',
//                   left: '15px',
//                   top: '15px',
//                   background: '#CAC2C2CC',
//                   borderRadius: '8px',
//                   fontFamily: "'Montserrat', sans-serif",
//                   fontStyle: 'normal',
//                   fontWeight: 500,
//                   fontSize: '14px',
//                   lineHeight: '157%',
//                   textAlign: 'center',
//                   letterSpacing: '0.1px',
//                   overflow: 'hidden',
//                   color: 'black',
//                   zIndex: 100,
//                   // maxWidth: 'calc(100vw - 150px)',
//                   '@media (max-width: 900px) and (orientation: landscape)': {
//                     fontSize: '14px',
//                     fontWeight: 800,
//                     color: 'black',
//                     top: '70px'
//                   }
//                 }}
//               >
//               {/* {
//               currentImageTitle?.viewName === "Face"
//                 ? "Take photo of the Face of the animal"
//                 : currentImageTitle?.viewName === "Deceased Body"
//                 ? "Take photo of Deceased Body of the animal"
//                 : currentImageTitle?.viewName === "Ear Tag + Forehead"
//                 ? "Take photo of eartag with the forehead of the animal"
//                 : currentImageTitle?.viewName === "Muzzle 1"
//                 ? "Take photo of muzzle view 1 of the animal"
//                 : currentImageTitle?.viewName === "Muzzle 2"
//                 ? "Take photo of muzzle view 2 of the animal"
//                 : currentImageTitle?.viewName === "Muzzle 3"
//                 ? "Take photo of muzzle view 3 of the animal"
//                 : currentImageTitle?.viewName
//                 ? `Take photo of the ${currentImageTitle.viewName.toLowerCase()} of the animal`
//                 : "Loading..."
//             } */}
// {getInstructionText(currentImageTitle?.viewName)}

//                </Typography>

//               {/* PROGRESS BAR + ACCORDION ICON */}
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'flex-end',
//                   position: 'fixed',
//                   top: '12px',
//                   right: '12px',
//                   left: 'auto',
//                   zIndex: 1300,
//                   gap: '6px'
//                 }}
//               >
//                 {/* Progress bar (toggled by Frame icon) */}
//                 {isProgressVisible && (
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       justifyContent: 'center',
//                       alignItems: 'center',
//                       padding: '8px',
//                       gap: '10px',
//                       width: '20vw',
//                       height: '38px',
//                       background: '#FFFFFF99',
//                       borderRadius: '8px',
//                       whiteSpace: 'nowrap',
//                       overflow: 'hidden',
//                       boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
//                     }}
//                   >
//                     <ImageProgressBar2 />
//                   </Box>
//                 )}
                
//                 {/* Frame Icon (toggles progress bar) */}
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     width: '40px',
//                     height: '40px',
//                     background: '#FFFFFF',
//                     borderRadius: '8px',
//                     cursor: 'pointer',
//                     transition: 'transform 0.3s ease',
//                     // transform: isProgressVisible ? 'rotate(180deg)' : 'rotate(0deg)',
//                     // boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
//                     // zIndex: 1302,
//                     pointerEvents: 'auto',
//                     '&:hover': {
//                       background: '#FFFFFFCC',
//                     }
//                   }}
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     setIsProgressVisible(!isProgressVisible);
//                   }}
//                 >
//                   <img
//                     src={Frame}
//                     alt="Toggle Progress Bar"
//                     style={{
//                       width: '39px',
//                       height: '59px',
//                       objectFit: 'contain',
//                     }}
//                   />
//                 </Box>
//               </Box>
              
//               {/* SUGGESTION FOR LIGHTING */}
//               {suggestion && (!imageCaptured || !videoCaptured) && (
//                 <Typography
//                   sx={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     padding: '8px 8px',
//                     gap: '8px',
//                     position: 'absolute',
//                     width: 'auto',
//                     height: '33px',
//                     left: '10px',
//                     bottom: '30px',
//                     background: 'rgba(255, 255, 255, 0.6)',
//                     borderRadius: '8px',
//                     fontFamily: "'Montserrat', sans-serif",
//                     fontStyle: 'normal',
//                     fontWeight: 500,
//                     fontSize: '13px',
//                     lineHeight: '157%',
//                     textAlign: 'center',
//                     letterSpacing: '0.1px',
//                     whiteSpace: 'nowrap',
//                     overflow: 'hidden',
//                     color: 'black',
//                     zIndex: 100,
//                     '@media (max-width: 900px)and (orientation: landscape)': {
//                       fontSize: '12px'
//                     }
//                   }}
//                 >
//                   {suggestion}
//                 </Typography>
//               )}
//               {/* CAMERA STEPS(TOP-RIGHT CORNER) */}

//               {/* camera container */}
//               <div
//                 className='image-page'
//                 style={{
//                   display: 'flex',
//                   flexDirection: 'row',
//                   width: windowDimensions.width, //"100%",
//                   height: windowDimensions.height, //"100svh",
//                   display: imageCaptured || videoCaptured ? 'none' : 'flex'
//                   // position: "relative",
//                 }}
//                 ref={containerRef}
//               >
//                 {/* camera */}
//                 <div
//                   className='webcam-container'
//                   style={{
//                     width: '100vw',
//                     height: '100svh', // Use safe viewport height for better compatibility
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     backgroundColor: 'black', // For letterboxing effect
//                     overflow: 'hidden',
//                     position: 'relative'
//                   }}
//                 >
//                   <div
//                     style={{
//                       position: 'absolute',
//                       top: '5px',
//                       left: '50%',
//                       transform: 'translateX(-50%)',
//                       zIndex: 10,
//                       backgroundColor: 'rgba(0, 0, 0, 0.5)',
//                       color: 'white',
//                       padding: '5px 10px',
//                       borderRadius: '5px',
//                       height: '20px',
//                       fontSize: '0.8rem',
//                       display: 'flex',
//                       alignItems: 'center'
//                     }}
//                   >
//                     {zoomLevel !== '!'
//                       ? `Zoom: ${zoomLevel}x`
//                       : 'Zoom not detected'}
//                   </div>
//                   {console.log(
//                     'videoConstraintsRef.current: ',
//                     videoConstraintsRef.current
//                   )}
//                   <Webcam
//                     audio={
//                       !!userId &&
//                       userId !== 'UID101' &&
//                       userId !== 'USR_291628' &&
//                       userId !== 'USR_542794'
//                     }
//                     muted={true}
//                     mirrored={false}
//                     ref={webcamRef}
//                     height='100%'
//                     width='100%'
//                     screenshotFormat='image/jpeg'
//                     screenshotQuality={1}
//                     videoConstraints={videoConstraintsRef.current}
//                     className='webcam'
//                     style={{
//                       position: 'absolute',
//                       textAlign: 'center',
//                       zIndex: 8,
//                       right: 0,
//                       left: 0,
//                       top: 0,
//                       bottom: 0,
//                       objectFit: 'contain', // Ensures full feed is visible with letterboxing
//                       backgroundColor: 'black' // Background to simulate letterboxing
//                     }}
//                   />
//                 </div>
//                 {/* for network toast message */}
//                 <ToastContainer />
//                 {/* STENCILS */}
//                 {stencilFolder && currentImageTitle?.imageStencils && (
//                   <img
//                     src={currentImageTitle?.imageStencils}
//                     alt='Car'
//                     style={{
//                       position: 'absolute',
//                       width: '100vw',
//                       height: '100svh',
//                       objectFit: 'cover',
//                       zIndex: 9,
//                       opacity: 0.35
//                     }}
//                   />
//                 )}
//                 {/* VIDEO TIMER FOR RPM METER */}
//                 <div
//                   style={{
//                     position: 'absolute',
//                     right: '50%',
//                     top: '50%',
//                     transform: 'translate(50%, -50%)',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     padding: '0.5rem 1rem',
//                     zIndex: 2000,
//                     color: 'white',
//                     fontSize: '1.5rem',
//                     borderRadius: '50%'
//                   }}
//                 >
//                   {timerRef.current - 1 <= 5 && (
//                     <VideoTimer number={timerRef.current - 1} />
//                   )}
//                 </div>
//                 {!btnType && (
//                   <Typography
//                     sx={{
//                       display: 'flex',
//                       flexDirection: 'column',
//                       justifyContent: 'center',
//                       alignItems: 'center',
//                       padding: '8px 8px',
//                       gap: '10px',
//                       position: 'absolute',
//                       width: 'auto',
//                       height: '33px',
//                       right: '15px',
//                       top: '100px',
//                       background: 'rgba(255, 255, 255, 0.6)',
//                       borderRadius: '8px',
//                       fontFamily: "'Montserrat', sans-serif",
//                       fontStyle: 'normal',
//                       fontWeight: 500,
//                       fontSize: '14px',
//                       lineHeight: '157%',
//                       textAlign: 'center',
//                       letterSpacing: '0.1px',
//                       whiteSpace: 'nowrap',
//                       overflow: 'hidden',
//                       color: 'black',
//                       zIndex: 100,
//                       '@media (max-width: 900px)and (orientation: landscape)': {
//                         fontSize: '12px'
//                       }
//                     }}
//                   >
//                     {formatTime(timerRef.current - 1)}
//                   </Typography>
//                 )}
//                 {/* capture button */}
//                 <div
//                   style={{
//                     position: 'absolute',
//                     right: '1.5rem',
//                     height: '100svh',
//                     display: 'flex',
//                     justifyContent: 'flex-end',
//                     flexDirection: 'column',
//                     gap: '1rem',
//                     top: '44px',
//                     zIndex: 2000
//                   }}
//                 >
//                   <div
//                     style={{
//                       position: "fixed",
//                       bottom: "139px",
//                       right: "15px",
//                     }}
//                   >
//                     {/* {currentImageTitle?.mode === 'photo' ? ( */}
//                     {(!currentImageTitle?.mode || currentImageTitle?.mode === 'photo') ? (
//                       <button style={buttonStyle} onClick={capturePhoto}>
//                         <div style={innerCircleStyle}></div>
//                       </button>
//                     ) : (
//                       <div
//                         style={{
//                           ...buttonStyle,
//                           opacity: isDisabled ? 0.5 : 1,
//                           pointerEvents: isDisabled ? 'none' : 'auto',
//                           cursor: isDisabled ? 'not-allowed' : 'pointer'
//                         }}
//                         onClick={!isDisabled && (btnType ? handleStartCaptureClick : handleStopCaptureClick)}
//                       >
//                         <div style={{ ...innerCircleStyle, backgroundColor: btnType ? "green" : "#F44336" }}></div>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               {imageCaptured && (
//                 <div
//                   style={{
//                     width: '100vw',
//                     height: '100svh',
//                     overflow: 'hidden',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     backgroundColor: 'black'
//                   }}
//                 >
//                   <div
//                     style={{
//                       position: 'absolute',
//                       top: '60%',
//                       transform: 'translateY(-50%)',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       alignContent: 'center',
//                       justifyContent: 'center',
//                       gap: '6rem'
//                     }}
//                   >
//                     {
//                       (!currentImageTitle?.mode || currentImageTitle?.mode === 'photo')
//                      ? (
//                         <>
//                           <CustomToastify />
//                           <button
//                             style={{
//                               display: 'flex',
//                               alignItems: 'center',
//                               justifyContent: 'center',
//                               gap: '0.2rem',
//                               border: '1.5px solid #FC350B',
//                               padding: '0rem 1.2rem',
//                               backgroundColor: 'white',
//                               borderRadius: '5px',
//                               opacity: '0.9'
//                             }}
//                           >
//                             <img
//                               src={reload}
//                               style={{ width: '1rem', height: '1rem' }}
//                             ></img>
//                             <p
//                               style={{
//                                 fontSize: '1rem',
//                                 fontFamily: "'Montserrat', sans-serif",
//                                 color: '#FC350B',
//                                 padding: '0.5rem',
//                                 cursor: 'pointer'
//                               }}
//                               onClick={handleRetakeClick}
//                             >
//                               Retake
//                             </p>
//                           </button>
//                         </>
//                       ) : (
//                         <>
//                           <CustomVideoToastify />
//                           <button
//                             style={{
//                               display: 'flex',
//                               alignItems: 'center',
//                               justifyContent: 'center',
//                               gap: '0.2rem',
//                               border: '1.5px solid #FC350B',
//                               padding: '0rem 1.2rem',
//                               backgroundColor: 'white',
//                               borderRadius: '5px',
//                               opacity: '0.9'
//                             }}
//                           >
//                             <img
//                               src={reload}
//                               style={{ width: '1rem', height: '1rem' }}
//                             ></img>
//                             <p
//                               style={{
//                                 fontSize: '1rem',
//                                 fontFamily: "'Montserrat', sans-serif",
//                                 color: '#FC350B',
//                                 padding: '0.5rem',
//                                 cursor: 'pointer'
//                               }}
//                               onClick={handleRetakeForVideo}
//                             >
//                               Retake
//                             </p>
//                           </button>
//                         </>
//                       ) //useless
//                     }
//                   </div>

//                   {currentImageTitle?.mode === 'photo' && (
//                     <img
//                       src={URL.createObjectURL(image)}
//                       alt='Captured'
//                       style={{
//                         width: '100%',
//                         height: '100%',
//                         objectFit: 'contain' //changed
//                       }}
//                     />
//                   )}
//                 </div>
//               )}
//              {/* after rpm meter vdo is captured */}
//              {videoCaptured && (
//                 <div
//                   style={{
//                     width: '100vw',
//                     height: '100svh',
//                     overflow: 'hidden',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     backgroundColor: 'black'
//                   }}
//                 >
//                   <div
//                     style={{
//                       position: 'absolute',
//                       top: '60%',
//                       transform: 'translateY(-50%)',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       alignContent: 'center',
//                       justifyContent: 'center',
//                       gap: '6rem'
//                     }}
//                   >
//                     {
//                       (!currentImageTitle?.mode || currentImageTitle?.mode === 'photo') ? (            
//                         <>
//                           <CustomToastify />
//                           <button
//                           style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             gap: '0.2rem',
//                             border: '1.5px solid #FC350B',
//                             padding: '0rem 1.2rem',
//                             backgroundColor: 'white',
//                             borderRadius: '5px',
//                             opacity: '0.9'
//                           }}
//                         >
//                           <img
//                             src={reload}
//                             style={{ width: '1rem', height: '1rem' }}
//                           ></img>
//                           <p
//                             style={{
//                               fontSize: '1rem',
//                               fontFamily: "'Montserrat', sans-serif",
//                               color: '#FC350B',
//                               padding: '0.5rem',
//                               cursor: 'pointer'
//                             }}
//                             onClick={handleRetakeClick}
//                           >
//                             Retake
//                           </p>
//                         </button>
//                       </>
//                     ) : (
//                       <>
//                         <CustomVideoToastify />
//                         <button
//                           style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             gap: '0.2rem',
//                             border: '1.5px solid #FC350B',
//                             padding: '0rem 1.2rem',
//                             backgroundColor: 'white',
//                             borderRadius: '5px',
//                             opacity: '0.9'
//                           }}
//                         >
//                           <img
//                             src={reload}
//                             style={{ width: '1rem', height: '1rem' }}
//                           ></img>
//                           <p
//                             style={{
//                               fontSize: '1rem',
//                               fontFamily: "'Montserrat', sans-serif",
//                               color: '#FC350B',
//                               padding: '0.5rem',
//                               cursor: 'pointer'
//                             }}
//                             onClick={handleRetakeForVideo}
//                           >
//                             Retake
//                           </p>
//                         </button>
//                       </>
//                     )}
//                   </div>

//                   {currentImageTitle?.mode === 'photo' && (
//                     <img
//                       src={URL.createObjectURL(image)}
//                       alt='Captured'
//                       style={{
//                         width: '100%',
//                         height: '100%',
//                         objectFit: 'cover'
//                       }}
//                     />
//                   )}
//                 </div>
//               )}
//             </>
//           )}
//         </>
//       )}

//       <SnackbarAlert />
//     </div>
//   )
// }

// export default CameraModule2
// CameraModule2.jsx
// import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import Webcam from "react-webcam";
// import moment from "moment";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box, Typography } from "@mui/material";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// import FileContext from "../context/Context";
// import { SnackbarAlert } from "../custom-component/AlertMessage";
// import ImageProgressBar2 from "./ImageProgressBar2";
// import CustomToastify from "./custom-notified-msg/CustomToastify";
// import CustomVideoToastify from "./custom-notified-msg/CustomVideoToastify";
// import VideoTimer from "../video-module/video-timer/VideoTimer";
// import Photo_Video_Instruction from "./photo_video_instruction/Photo_Video_Instruction";

// import Frame from "../imagesicons/Frame.png";
// import "./style.css";
// import "./camera.css";

// import {
//   setAlertMessageSnackbarMessageSeverity,
//   setAlertMessageSnackbarMsg,
//   setAlertMessageSnackbarOpen
// } from "../store/feedback";
// import { set_image_upload_status } from "../store/image_upload";
// import { useFullscreen } from "../context/FullScreenContext";

// const CameraModule2 = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { audit_id  } = useParams();   // ✅ this will come from /claim/camera/:id
//   const id = audit_id;               // ✅ use this everywhere instead of auditID / id mix

//   const { requestFullscreen } = useFullscreen();

//   const { latitude, longitude } = useSelector((state) => state.imagesStore);

//   const {
//     setCapturedImages360,
//     setCapturedImageWindshield,
//     setCapturedChassisRC,
//     setCapturedRegNo,
//     setCapturedOdometer,
//     setCapturedTyres,
//     capturedInspectionImages,
//     setCapturedInspectionImages,
//     setOdometerVideo
//   } = useContext(FileContext);

//   const [open, setOpen] = useState(false);
//   const [showInstructionPage, setShowInstructionPage] = useState(false);

//   const [dialogWidth, setDialogWidth] = useState("29vw");
//   const [dialogText, setDialogText] = useState("0.9rem");

//   const [btnType, setBtnType] = useState(true);
//   const [isDisabled, setIsDisabled] = useState(false);

//   const [videoCaptured, setVideoCaptured] = useState(false);
//   const [imageCaptured, setImageCaptured] = useState(false);

//   const [capturedTime, setCapturedTime] = useState(null);
//   const [hasRetaken, setHasRetaken] = useState(false);

//   const [zoomLevel, setZoomLevel] = useState(1);

//   const [image, setImage] = useState(null);
//   const webcamRef = useRef(null);

//   const timerRef = useRef(31);
//   const intervalRef = useRef(null);
// // ✅ prevent multiple API calls per capture
// const hasSavedRef = useRef(false);

//   const mediaRecorderRef = useRef(null);
//   const recordedChunksRef = useRef([]);

//   const reload = require("./Reload.png");

//   const [windowDimensions, setWindowDimensions] = useState({
//     width: window.innerWidth,
//     height: window.innerHeight
//   });

//   const [isProgressVisible, setIsProgressVisible] = useState(true);

//   const storedConfig = localStorage.getItem("inspectionConfiguration");
//   const inspectionConfig = storedConfig ? JSON.parse(storedConfig).inspection_config : null;

//   // Your user id logic unchanged 
//   const insuranceUser = JSON.parse(localStorage.getItem("insuranceUser"));
//   const insuranceUserID = JSON.parse(localStorage.getItem("inspectionConfiguration"));
//   const userId = insuranceUser?.userId || insuranceUserID?.userID;

//   // ✅ Define your capture list once
//   const imagesToCapture = useMemo(
//     () => [
//       { viewName: "Face", imageName: "Face", mode: "photo", id: 1 },
//       { viewName: "Deceased Body", imageName: "Deceased Body", mode: "photo", id: 2 },
//       { viewName: "Ear Tag + Forehead", imageName: "Ear Tag + Forehead", mode: "photo", id: 3 },
//       { viewName: "Muzzle 1", imageName: "Muzzle 1", mode: "photo", id: 4 },
//       { viewName: "Muzzle 2", imageName: "Muzzle 2", mode: "photo", id: 5 },
//       { viewName: "Muzzle 3", imageName: "Muzzle 3", mode: "photo", id: 6 }
//     ],
//     []
//   );

//   // ✅ Compute mandatory images reliably
//   // const mandatoryImages = useMemo(() => {
//   //   if (inspectionConfig?.selectedItems?.length) {
//   //     const selected = inspectionConfig.selectedItems || [];
//   //     const pick = (name) =>
//   //       imagesToCapture.find((x) => x.imageName === name || x.viewName === name);

//   //     const list = [];
//   //     ["Face", "Deceased Body", "Ear Tag + Forehead", "Muzzle 1", "Muzzle 2", "Muzzle 3"].forEach((k) => {
//   //       if (selected.includes(k)) {
//   //         const img = pick(k);
//   //         if (img) list.push(img);
//   //       }
//   //     });

//   //     // fallback
//   //     return list.length ? list : [...imagesToCapture];
//   //   }
//   //   return [...imagesToCapture];
//   // }, [inspectionConfig, imagesToCapture]);
// const mandatoryImages = useMemo(() => {
//   return [...imagesToCapture];
// }, [imagesToCapture]);

//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [currentImageTitle, setCurrentImageTitle] = useState(mandatoryImages[0] || null);

//   // ✅ keep currentImageTitle synced when list changes
//   useEffect(() => {
//     if (!mandatoryImages.length) return;
//     setCurrentImageIndex((idx) => (idx < mandatoryImages.length ? idx : 0));
//     setCurrentImageTitle((prev) => (prev?.viewName ? prev : mandatoryImages[0]));
//   }, [mandatoryImages]);

//   // Responsive dialog sizing
//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth <= 400) setDialogWidth("85vw");
//       else if (window.innerWidth <= 475) setDialogWidth("74vw");
//       else if (window.innerWidth <= 575) {
//         setDialogText("0.6rem");
//         setDialogWidth("64vw");
//       } else if (window.innerWidth <= 650) setDialogWidth("60vw");
//       else if (window.innerWidth <= 775) setDialogWidth("57vw");
//       else if (window.innerWidth <= 875) setDialogWidth("55vw");
//       else if (window.innerWidth <= 1000) setDialogWidth("48vw");
//       else if (window.innerWidth <= 1100) {
//         setDialogWidth("45vw");
//         setDialogText("0.8rem");
//       } else if (window.innerWidth <= 1300) setDialogWidth("40vw");
//       else setDialogWidth("35vw");
//     };
//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // window dims (camera)
//   useEffect(() => {
//     const handleResize = () => {
//       setWindowDimensions({ width: window.innerWidth, height: window.innerHeight });
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // ✅ Network check guarded so it never crashes your flow
//   useEffect(() => {
//     const checkNetwork = () => {
//       const cur = mandatoryImages[currentImageIndex];
//       if (!cur) return;

//       if (cur.id >= 15 && cur.id < 18) {
//         if (navigator.connection) {
//           const { downlink, effectiveType } = navigator.connection;

//           if (downlink < 5 || effectiveType === "3g" || effectiveType === "2g") {
//             toast.warn("Network is poor", {
//               position: "bottom-right",
//               autoClose: 3000,
//               hideProgressBar: false,
//               closeOnClick: true,
//               pauseOnHover: false,
//               draggable: false,
//               theme: "colored",
//               style: {
//                 backgroundColor: "#FC350B",
//                 color: "#fffff",
//                 width: "auto",
//                 maxWidth: "300px",
//                 padding: "10px 20px"
//               }
//             });
//           }
//         }
//       }
//     };

//     checkNetwork();
//     const interval = setInterval(checkNetwork, 30000);
//     return () => clearInterval(interval);
//   }, [currentImageIndex, mandatoryImages]);

//   // Webcam constraints
//   const [activeDeviceId, setActiveDeviceId] = useState(null);
//   const videoConstraintsRef = useRef({
//     height: 1920,
//     width: 1080,
//     deviceId: null,
//     facingMode: "environment"
//   });

//   useEffect(() => {
//     videoConstraintsRef.current = {
//       height: 1920,
//       width: 1080,
//       deviceId: activeDeviceId ? activeDeviceId : null,
//       facingMode: "environment"
//     };
//   }, [activeDeviceId]);

//   const handleDevices = useCallback((mediaDevices) => {
//     const videoInputs = mediaDevices.filter((d) => d.kind === "videoinput");
//     const preferred = videoInputs.find((d) => d.label.toLowerCase().includes("0"));
//     if (preferred) setActiveDeviceId(preferred.deviceId);
//   }, []);

//   useEffect(() => {
//     navigator.mediaDevices?.enumerateDevices?.().then(handleDevices).catch(() => {});
//   }, [handleDevices]);

//   // Zoom apply
//   useEffect(() => {
//     const applyZoom = async () => {
//       try {
//         const stream = webcamRef.current?.video?.srcObject;
//         if (!stream) return;
//         const track = stream.getVideoTracks()[0];
//         if (!track) return;

//         const capabilities = track.getCapabilities?.();
//         if (capabilities?.zoom) {
//           const settings = track.getSettings?.();
//           setZoomLevel(settings?.zoom || 1);

//           await track.applyConstraints({ advanced: [{ zoom: 1.08 }] });
//           setZoomLevel(1.0);
//         }
//       } catch (error) {
//         console.error("Error applying zoom:", error);
//       }
//     };

//     const v = webcamRef.current?.video;
//     if (v) v.addEventListener("loadedmetadata", applyZoom);
//     return () => {
//       if (v) v.removeEventListener("loadedmetadata", applyZoom);
//     };
//   }, []);

//   // Lighting analysis (same behavior)
//   const [suggestion, setSuggestion] = useState("");
//   const [perfectImage, setPerfectImage] = useState(false);

//   const analyzeLighting = (imageData) => {
//     const { data, width, height } = imageData;
//     let totalBrightness = 0;
//     for (let i = 0; i < data.length; i += 4) {
//       totalBrightness += (data[i] + data[i + 1] + data[i + 2]) / 3;
//     }
//     const avg = totalBrightness / (width * height);
//     if (avg < 100) return "Increase lighting.";
//     if (avg > 200) return "Reduce lighting.";
//     return "Lighting looks good.";
//   };

//   const captureAndAnalyze = useCallback(() => {
//     const cam = webcamRef.current;
//     if (!cam?.getScreenshot) return;

//     const imageSrc = cam.getScreenshot();
//     if (!imageSrc) return;

//     const img = new Image();
//     img.src = imageSrc;
//     img.onload = () => {
//       const canvas = document.createElement("canvas");
//       const ctx = canvas.getContext("2d");
//       canvas.width = img.width;
//       canvas.height = img.height;
//       ctx.drawImage(img, 0, 0, img.width, img.height);
//       const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
//       const lightingSuggestion = analyzeLighting(imageData);
//       setSuggestion(lightingSuggestion);
//       setPerfectImage(lightingSuggestion === "Lighting looks good.");
//     };
//   }, []);

//   useEffect(() => {
//     const interval = setInterval(captureAndAnalyze, 500);
//     return () => clearInterval(interval);
//   }, [captureAndAnalyze]);

//   // Utils
//   const azure_image_file_name = (audit, cattleNum, image_name, file_name) => {
//     return `${cattleNum}_${image_name}_${file_name}`;
//   };

//   const base64ToBlob = (base64, contentType = "image/png") => {
//     const byteCharacters = atob(base64);
//     const byteArrays = [];
//     for (let offset = 0; offset < byteCharacters.length; offset += 512) {
//       const slice = byteCharacters.slice(offset, offset + 512);
//       const byteNumbers = new Array(slice.length);
//       for (let i = 0; i < slice.length; i++) byteNumbers[i] = slice.charCodeAt(i);
//       byteArrays.push(new Uint8Array(byteNumbers));
//     }
//     return new Blob(byteArrays, { type: contentType });
//   };

//   const cacheImageBuffer = async (fileName, base64String, clicked_time, name, type, auditId, lat, lng) => {
//     try {
//       const cache = await caches.open("image-cache");
//       const imageBlob = base64ToBlob(base64String, "image/png");

//       const metadata = JSON.stringify({
//         clicked_time,
//         name,
//         type,
//         id: auditId,
//         latitude: lat,
//         longitude: lng
//       });

//       await cache.put(`${fileName}`, new Response(imageBlob, { headers: { "Content-Type": "image/png" } }));
//       await cache.put(`${fileName}-metadata`, new Response(metadata, { headers: { "Content-Type": "application/json" } }));
//     } catch (error) {
//       console.error("Failed to cache image+metadata:", error);
//     }
//   };

//   const upload_image_to_s3 = async (
//     auditId,
//     imgId,
//     clicked_time,
//     lat,
//     lng,
//     fileName,
//     base64String,
//     image_name
//   ) => {
//     try {
//       axios.post("/aiProcessingApis/uploadToTopic", {
//         id: imgId,
//         auditID: auditId,
//         image_name: fileName,
//         imageCategory: image_name,
//         clicked_time,
//         latitude: lat,
//         longitude: lng
//       });

//       if (!base64String || base64String.length < 1000) return;

//       const byteCharacters = atob(base64String);
//       const byteNumbers = new Array(byteCharacters.length);
//       for (let i = 0; i < byteCharacters.length; i++) byteNumbers[i] = byteCharacters.charCodeAt(i);
//       const blob = new Blob([new Uint8Array(byteNumbers)], { type: "image/jpeg" });

//       const formData = new FormData();
//       formData.append("blobName", `Cattle_Insurance_Inspection/auditImages/claimImages/${fileName}`);
//       formData.append("file", blob, fileName);
//       formData.append("contentType", "image/jpeg");

//       const response = await axios.post("/process_data/upload-img", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//         maxContentLength: Infinity,
//         maxBodyLength: Infinity
//       });

//       if (response.status === 200) {
//         dispatch(set_image_upload_status({ image_name, status: 1, type: "s3_img_upload_status" }));
//       }
//     } catch (error) {
//       console.error("Error uploading image:", error?.message || error);
//     }
//   };

//   const axiosInstance = axios.create({ timeout: 30000 });

//   const upload_images_data_db = async (formData, image_name) => {
//     try {
//       const response = await axiosInstance.post("/process_data/upload_process_store_claim_individually", formData, {
//         headers: { "Content-Type": "multipart/form-data" }
//       });

//       if (response.status === 200) {
//         dispatch(set_image_upload_status({ image_name, status: 1, type: "sql_upload_status" }));
//       }
//     } catch (error) {
//       console.error("DB upload failed:", error);
//     }
//   };

//   // ✅ Capture photo (guarded so it never crashes)
//   const capturePhoto = useCallback(() => {
//     const cam = webcamRef.current;
//     if (!cam?.getScreenshot) return;

//     const imageSrc = cam.getScreenshot({ quality: 1 });
//     if (!imageSrc) {
//       console.warn("imageSrc is null");
//       return;
//     }

//     const formattedCaptureTime = moment().format("YYYY-MM-DD HH:mm:ss");

//     const dataURLtoBlob = (dataURL) => {
//       if (!dataURL || typeof dataURL !== "string" || !dataURL.startsWith("data:")) return null;
//       const parts = dataURL.split(",");
//       if (parts.length < 2) return null;

//       const byteString = atob(parts[1]);
//       const mimeString = parts[0].split(":")[1].split(";")[0];
//       const ab = new ArrayBuffer(byteString.length);
//       const ia = new Uint8Array(ab);
//       for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
//       return new Blob([ab], { type: mimeString });
//     };

//     const blob = dataURLtoBlob(imageSrc);
//     if (!blob) return;

//     const file = new File([blob], "captured_image.jpeg", { type: "image/jpeg" });
//     hasSavedRef.current = false; // allow save for new capture
//     setImage(file);
//     setCapturedTime(formattedCaptureTime);
//     setImageCaptured(true);
//   }, []);

//   // ✅ Save (guarded) + uploads
//   const handleSave = useCallback(() => {
//     try {
//       if (!id) {
//         dispatch(setAlertMessageSnackbarMsg("Audit not found !"));
//         dispatch(setAlertMessageSnackbarMessageSeverity("error"));
//         dispatch(setAlertMessageSnackbarOpen(true));
//         setTimeout(() => dispatch(setAlertMessageSnackbarOpen(false)), 5000);
//         navigate("/");
//         return;
//       }

//       const currentImage = mandatoryImages[currentImageIndex];
//       if (!currentImage) {
//         console.error("currentImage undefined at index", currentImageIndex);
//         return;
//       }
//       if (!image) {
//         console.error("No image file found to save");
//         return;
//       }

//       const res = {
//         file: image,
//         name: currentImage.imageName,
//         clickedTime: capturedTime,
//         id: currentImage.id,
//         latitude,
//         longitude
//       };

//       // categorize (kept from your original)
//       if (res.name === "inner_windshield" || res.name === "outer_windshield") setCapturedImageWindshield((p) => [...p, res]);
//       else if (res.name === "registrationNo") setCapturedRegNo((p) => [...p, res]);
//       else if (res.name === "chassis" || res.name === "RC") setCapturedChassisRC((p) => [...p, res]);
//       else if (res.name === "odometer") setCapturedOdometer((p) => [...p, res]);
//       else if (["front_left_tyre", "back_left_tyre", "back_right_tyre", "front_right_tyre"].includes(res.name)) setCapturedTyres((p) => [...p, res]);
//       else setCapturedImages360((p) => [...p, res]);

//       // ✅ prevent duplicates by id
//       setCapturedInspectionImages((prev) => {
//         const filtered = prev.filter((x) => x.id !== res.id);
//         return [...filtered, res];
//       });

//       // filename
//       const cattleNum = localStorage.getItem("cattle num") || "cattle";
//       const fileName = azure_image_file_name(id, cattleNum, res.name, res.file.name);

//       const reader = new FileReader();
//       reader.onloadend = () => {
//         const dataUrl = reader.result;
//         const base64String = String(dataUrl).split(",")[1];

//         cacheImageBuffer(fileName, base64String, res.clickedTime, res.name, res.id, id, latitude, longitude);

//         upload_image_to_s3(id, res.id, res.clickedTime, latitude, longitude, fileName, base64String, res.name);

//         const formData = new FormData();
//         formData.append("clickedTime", res.clickedTime);
//         formData.append("name", res.name);
//         formData.append("id", res.id);
//         formData.append("auditID", id);
//         formData.append("latitude", latitude);
//         formData.append("longitude", longitude);
//         formData.append("azure_image_name", fileName);
//         formData.append("cattlenumber", id);
//         formData.append("type", res.id);

//         upload_images_data_db(formData, res.name);
//       };

//       reader.readAsDataURL(image);
//     } catch (e) {
//       // ✅ This is the main reason your "API not called + next not initiated" happened earlier
//       console.error("handleSave crashed:", e);
//     }
//   }, [
//     id,
//     dispatch,
//     navigate,
//     mandatoryImages,
//     currentImageIndex,
//     image,
//     capturedTime,
//     latitude,
//     longitude,
//     setCapturedInspectionImages,
//     setCapturedImages360,
//     setCapturedImageWindshield,
//     setCapturedChassisRC,
//     setCapturedRegNo,
//     setCapturedOdometer,
//     setCapturedTyres
//   ]);

//   // After capture -> auto save -> advance
//   useEffect(() => {
//     if ((imageCaptured || videoCaptured) && !hasRetaken) {
//       // if (imageCaptured) {
//       //   handleSave();
//       // }
//   if (imageCaptured && !hasSavedRef.current) {
//       hasSavedRef.current = true;
//       handleSave();
//     }
//       const timer = setTimeout(() => {
//         const nextIndex = currentImageIndex + 1;

//         if (nextIndex < mandatoryImages.length) {
//           setCurrentImageIndex(nextIndex);
//           setCurrentImageTitle(mandatoryImages[nextIndex]);
//           setShowInstructionPage(mandatoryImages[nextIndex]?.viewName === "RPM Meter Video");
//         }

//         setImageCaptured(false);
//         setVideoCaptured(false);
//       }, 6000);

//       return () => clearTimeout(timer);
//     }
//   }, [hasRetaken, imageCaptured, videoCaptured, handleSave, currentImageIndex, mandatoryImages]);

//   // Completion navigate
//   useEffect(() => {
//     console.log(capturedInspectionImages.length,mandatoryImages.length,2982)
//     if (capturedInspectionImages.length === mandatoryImages.length && mandatoryImages.length > 0) {
//       const timer = setTimeout(() => {
//      navigate('/auditList', {
//      state: { activeTab: 'claim' }
//       });
//       }, 6000);

//       return () => clearTimeout(timer);
//     }
//   }, [capturedInspectionImages, mandatoryImages, id, navigate]);

//   // Inactivity timer
//   useEffect(() => {
//     const checkInactivityTimeout = () => {
//       const now = Date.now();
//       const last = sessionStorage.getItem("lastPhotoTimestamp");
//       if (last && now - parseInt(last, 10) > 14 * 60 * 1000) {
//         sessionStorage.removeItem("lastPhotoTimestamp");
//         dispatch(setAlertMessageSnackbarMsg("15-minute inactivity detected. Restarting inspection."));
//         dispatch(setAlertMessageSnackbarMessageSeverity("warning"));
//         dispatch(setAlertMessageSnackbarOpen(true));
//         navigate(-1);
//       }
//     };

//     const interval = setInterval(checkInactivityTimeout, 60000);
//     return () => clearInterval(interval);
//   }, [dispatch, navigate]);

//   // simple instruction mapping
//   const getInstructionText = (viewName) => {
//     const map = {
//       Face: "Take photo of the Face of the animal",
//       "Deceased Body": "Take photo of Deceased Body of the animal",
//       "Ear Tag + Forehead": "Take photo of eartag with the forehead of the animal",
//       "Muzzle 1": "Take photo of muzzle view 1 of the animal",
//       "Muzzle 2": "Take photo of muzzle view 2 of the animal",
//       "Muzzle 3": "Take photo of muzzle view 3 of the animal"
//     };

//     if (!viewName) return "Loading...";
//     return map[viewName] || `Take photo of the ${viewName.toLowerCase()} of the animal`;
//   };

//   const handleFullscreenRequest = () => {
//     requestFullscreen();
//     setOpen(false);
//   };

//   const handleCloseDialog = (event) => {
//     if (event.target.tagName.toLowerCase() !== "button" && !event.target.closest("button")) return;
//     setOpen(false);
//   };

//   const handleRetakeClick = () => {
//     setHasRetaken(true);
//     setImageCaptured(false);
//     setVideoCaptured(false);

//     setCapturedInspectionImages((prev) => {
//       if (!prev.length) return [];
//       return prev.slice(0, -1);
//     });

//     setTimeout(() => setHasRetaken(false), 50);
//   };

//   // Video capture (kept minimal; you can merge your full rpm logic back)
//   const handleStartCaptureClick = useCallback(() => {
//     setIsDisabled(true);
//     setTimeout(() => setIsDisabled(false), 10000);

//     setBtnType(false);
//     setCapturing(true);

//     recordedChunksRef.current = [];
//     clearInterval(intervalRef.current);
//     timerRef.current = 31;

//     const stream = webcamRef.current?.video?.srcObject;
//     if (!stream) return;

//     let mimeType = "video/webm";
//     if (MediaRecorder.isTypeSupported("video/mp4;codecs=avc1")) mimeType = "video/mp4;codecs=avc1";
//     else if (MediaRecorder.isTypeSupported("video/webm;codecs=vp9")) mimeType = "video/webm;codecs=vp9";
//     else if (MediaRecorder.isTypeSupported("video/webm;codecs=vp8")) mimeType = "video/webm;codecs=vp8";

//     const options = { mimeType, videoBitsPerSecond: 5000000, audioBitsPerSecond: 256000 };
//     // audio disabling logic (same)
//     if (!userId || userId === "UID101" || userId === "USR_291628" || userId === "USR_542794") {
//       delete options.audioBitsPerSecond;
//       stream.getAudioTracks().forEach((t) => t.stop());
//     }

//     const handleDataAvailable = ({ data }) => {
//       if (data.size > 0) {
//         recordedChunksRef.current.push(data);
//         if (currentImageTitle?.imageName === "rpm_meter_video") {
//           setOdometerVideo(recordedChunksRef.current);
//         }
//       }
//     };

//     try {
//       mediaRecorderRef.current = new MediaRecorder(stream, options);
//       mediaRecorderRef.current.addEventListener("dataavailable", handleDataAvailable);

//       intervalRef.current = setInterval(() => {
//         if (timerRef.current > 0) {
//           timerRef.current -= 1;
//           setCapturing((p) => !p);
//         }
//       }, 1000);

//       mediaRecorderRef.current.start();
//     } catch (e) {
//       console.error("MediaRecorder start failed:", e);
//     }
//   }, [userId, currentImageTitle, setOdometerVideo]);

//   const [capturing, setCapturing] = useState(false);

//   const handleStopCaptureClick = useCallback(() => {
//     setBtnType(true);
//     setVideoCaptured(true);

//     try {
//       mediaRecorderRef.current?.stop?.();
//     } catch (e) {}

//     setCapturing(false);
//     clearInterval(intervalRef.current);
//     timerRef.current = 31;
//   }, []);

//   useEffect(() => {
//     if (timerRef.current <= 0) handleStopCaptureClick();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [capturing]);

//   const buttonStyle = {
//     display: "flex",
//     cursor: "pointer",
//     alignItems: "center",
//     justifyContent: "center",
//     width: "72px",
//     height: "72px",
//     backgroundColor: "transparent",
//     borderRadius: "50%",
//     border: perfectImage ? "4px solid #4CAF50" : "4px solid white",
//     padding: "1px"
//   };

//   const innerCircleStyle = {
//     width: "55px",
//     height: "55px",
//     backgroundColor: "white",
//     borderRadius: "50%"
//   };

//   const formatTime = (seconds) => {
//     const minutes = Math.floor(seconds / 60);
//     const remainingSeconds = seconds % 60;
//     return `${minutes < 10 ? "0" : ""}${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
//   };

//   // ✅ instruction icon auto-hide
//   const [isIconVisible, setIsIconVisible] = useState(true);
//   useEffect(() => {
//     setIsIconVisible(true);
//     const t = setTimeout(() => setIsIconVisible(false), 18000);
//     return () => clearTimeout(t);
//   }, [currentImageTitle]);

//   // ✅ If audit missing
//   useEffect(() => {
//     if (!id) navigate("/");
//   }, [id, navigate]);

//   // (Optional) track last photo timestamp as in your old logic
//   useEffect(() => {
//     if (imageCaptured) sessionStorage.setItem("lastPhotoTimestamp", Date.now().toString());
//   }, [imageCaptured]);

//   return (
//     <div>
//       <Dialog
//         open={open}
//         onClose={handleCloseDialog}
//         className="full_screen_class"
//         PaperProps={{
//           style: { width: dialogWidth, padding: "0.5rem 0.5rem", paddingBottom: "0.5rem", borderRadius: "4px", margin: "0" }
//         }}
//       >
//         <DialogContent sx={{ padding: "0.2rem 0.3rem" }}>
//           <DialogTitle style={{ fontSize: dialogText, color: "black", padding: "0.4rem 0", fontWeight: "600" }}>
//             Full Screen Mode ?
//           </DialogTitle>
//           <DialogContentText sx={{ color: "black", fontSize: "0.8rem" }}>
//             Switch to full screen mode.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions sx={{ padding: "0.4rem" }}>
//           <div style={{ padding: "0.1rem" }}>
//             <button
//               onClick={handleFullscreenRequest}
//               style={{ color: "white", backgroundColor: "#FC350B", border: "none", padding: "0.4rem 0.8rem", textTransform: "capitalize", borderRadius: "20px", cursor: "pointer" }}
//             >
//               Switch
//             </button>
//           </div>
//         </DialogActions>
//       </Dialog>

//       <>
//         {showInstructionPage ? (
//           <Photo_Video_Instruction setShowInstructionPage={setShowInstructionPage} />
//         ) : (
//           <>
//             {/* TOP LEFT INSTRUCTION */}
//             <Typography
//               sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 padding: "8px 8px",
//                 gap: "10px",
//                 position: "absolute",
//                 width: "auto",
//                 height: "auto",
//                 left: "15px",
//                 top: "15px",
//                 background: "#CAC2C2CC",
//                 borderRadius: "8px",
//                 fontFamily: "'Montserrat', sans-serif",
//                 fontStyle: "normal",
//                 fontWeight: 500,
//                 fontSize: "14px",
//                 lineHeight: "157%",
//                 textAlign: "center",
//                 letterSpacing: "0.1px",
//                 overflow: "hidden",
//                 color: "black",
//                 zIndex: 100,
//                 "@media (max-width: 900px) and (orientation: landscape)": {
//                   fontSize: "14px",
//                   fontWeight: 800,
//                   color: "black",
//                   top: "70px"
//                 }
//               }}
//             >
//               {getInstructionText(currentImageTitle?.viewName)}
//             </Typography>

//             {/* TOP RIGHT: PROGRESS + TOGGLE */}
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "flex-end",
//                 position: "fixed",
//                 top: "12px",
//                 right: "12px",
//                 zIndex: 1300,
//                 gap: "6px"
//               }}
//             >
//               {isProgressVisible && (
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     padding: "8px",
//                     gap: "10px",
//                     width: "20vw",
//                     height: "38px",
//                     background: "#FFFFFF99",
//                     borderRadius: "8px",
//                     whiteSpace: "nowrap",
//                     overflow: "hidden",
//                     boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
//                   }}
//                 >
//                   <ImageProgressBar2 />
//                 </Box>
//               )}

//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   width: "40px",
//                   height: "40px",
//                   background: "#FFFFFF",
//                   borderRadius: "8px",
//                   cursor: "pointer",
//                   pointerEvents: "auto",
//                   "&:hover": { background: "#FFFFFFCC" }
//                 }}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   setIsProgressVisible(!isProgressVisible);
//                 }}
//               >
//                 <img src={Frame} alt="Toggle Progress Bar" style={{ width: "39px", height: "59px", objectFit: "contain" }} />
//               </Box>
//             </Box>

//             {/* LIGHTING SUGGESTION */}
//             {suggestion && !imageCaptured && !videoCaptured && (
//               <Typography
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   padding: "8px 8px",
//                   gap: "8px",
//                   position: "absolute",
//                   width: "auto",
//                   height: "33px",
//                   left: "10px",
//                   bottom: "30px",
//                   background: "rgba(255, 255, 255, 0.6)",
//                   borderRadius: "8px",
//                   fontFamily: "'Montserrat', sans-serif",
//                   fontWeight: 500,
//                   fontSize: "13px",
//                   lineHeight: "157%",
//                   textAlign: "center",
//                   letterSpacing: "0.1px",
//                   whiteSpace: "nowrap",
//                   overflow: "hidden",
//                   color: "black",
//                   zIndex: 100
//                 }}
//               >
//                 {suggestion}
//               </Typography>
//             )}

//             {/* CAMERA VIEW */}
//             <div
//               className="image-page"
//               style={{
//                 width: windowDimensions.width,
//                 height: windowDimensions.height,
//                 display: imageCaptured || videoCaptured ? "none" : "flex"
//               }}
//             >
//               <div
//                 className="webcam-container"
//                 style={{
//                   width: "100vw",
//                   height: "100svh",
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   backgroundColor: "black",
//                   overflow: "hidden",
//                   position: "relative"
//                 }}
//               >
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: "5px",
//                     left: "50%",
//                     transform: "translateX(-50%)",
//                     zIndex: 10,
//                     backgroundColor: "rgba(0, 0, 0, 0.5)",
//                     color: "white",
//                     padding: "5px 10px",
//                     borderRadius: "5px",
//                     height: "20px",
//                     fontSize: "0.8rem",
//                     display: "flex",
//                     alignItems: "center"
//                   }}
//                 >
//                   {`Zoom: ${zoomLevel}x`}
//                 </div>

//                 <Webcam
//                   audio={!!userId && userId !== "UID101" && userId !== "USR_291628" && userId !== "USR_542794"}
//                   muted={true}
//                   mirrored={false}
//                   ref={webcamRef}
//                   height="100%"
//                   width="100%"
//                   screenshotFormat="image/jpeg"
//                   screenshotQuality={1}
//                   videoConstraints={videoConstraintsRef.current}
//                   className="webcam"
//                   style={{
//                     position: "absolute",
//                     zIndex: 8,
//                     right: 0,
//                     left: 0,
//                     top: 0,
//                     bottom: 0,
//                     objectFit: "contain",
//                     backgroundColor: "black"
//                   }}
//                 />
//               </div>

//               <ToastContainer />

//               {/* TIMER (for video) */}
//               <div
//                 style={{
//                   position: "absolute",
//                   right: "50%",
//                   top: "50%",
//                   transform: "translate(50%, -50%)",
//                   zIndex: 2000,
//                   color: "white",
//                   fontSize: "1.5rem"
//                 }}
//               >
//                 {timerRef.current - 1 <= 5 && <VideoTimer number={timerRef.current - 1} />}
//               </div>

//               {!btnType && (
//                 <Typography
//                   sx={{
//                     position: "absolute",
//                     right: "15px",
//                     top: "100px",
//                     background: "rgba(255, 255, 255, 0.6)",
//                     borderRadius: "8px",
//                     padding: "8px",
//                     fontFamily: "'Montserrat', sans-serif",
//                     fontWeight: 500,
//                     fontSize: "14px",
//                     color: "black",
//                     zIndex: 100
//                   }}
//                 >
//                   {formatTime(timerRef.current - 1)}
//                 </Typography>
//               )}

//               {/* CAPTURE BUTTON */}
//               <div
//                 style={{
//                   position: "fixed",
//                   bottom: "139px",
//                   right: "15px",
//                   zIndex: 2000
//                 }}
//               >
//                 {(!currentImageTitle?.mode || currentImageTitle?.mode === "photo") ? (
//                   <button style={buttonStyle} onClick={capturePhoto}>
//                     <div style={innerCircleStyle} />
//                   </button>
//                 ) : (
//                   <div
//                     style={{
//                       ...buttonStyle,
//                       opacity: isDisabled ? 0.5 : 1,
//                       pointerEvents: isDisabled ? "none" : "auto",
//                       cursor: isDisabled ? "not-allowed" : "pointer"
//                     }}
//                     onClick={!isDisabled && (btnType ? handleStartCaptureClick : handleStopCaptureClick)}
//                   >
//                     <div style={{ ...innerCircleStyle, backgroundColor: btnType ? "green" : "#F44336" }} />
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* AFTER PHOTO CAPTURE */}
//             {imageCaptured && (
//               <div
//                 style={{
//                   width: "100vw",
//                   height: "100svh",
//                   overflow: "hidden",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   backgroundColor: "black"
//                 }}
//               >
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: "60%",
//                     transform: "translateY(-50%)",
//                     display: "flex",
//                     flexDirection: "column",
//                     alignContent: "center",
//                     justifyContent: "center",
//                     gap: "6rem"
//                   }}
//                 >
//                   <CustomToastify />
//                   <button
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       gap: "0.2rem",
//                       border: "1.5px solid #FC350B",
//                       padding: "0rem 1.2rem",
//                       backgroundColor: "white",
//                       borderRadius: "5px",
//                       opacity: "0.9"
//                     }}
//                   >
//                     <img src={reload} style={{ width: "1rem", height: "1rem" }} alt="reload" />
//                     <p
//                       style={{
//                         fontSize: "1rem",
//                         fontFamily: "'Montserrat', sans-serif",
//                         color: "#FC350B",
//                         padding: "0.5rem",
//                         cursor: "pointer"
//                       }}
//                       onClick={handleRetakeClick}
//                     >
//                       Retake
//                     </p>
//                   </button>
//                 </div>

//                 {image && (
//                   <img
//                     src={URL.createObjectURL(image)}
//                     alt="Captured"
//                     style={{ width: "100%", height: "100%", objectFit: "contain" }}
//                   />
//                 )}
//               </div>
//             )}

//             {/* AFTER VIDEO CAPTURE */}
//             {videoCaptured && (
//               <div
//                 style={{
//                   width: "100vw",
//                   height: "100svh",
//                   overflow: "hidden",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   backgroundColor: "black"
//                 }}
//               >
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: "60%",
//                     transform: "translateY(-50%)",
//                     display: "flex",
//                     flexDirection: "column",
//                     alignContent: "center",
//                     justifyContent: "center",
//                     gap: "6rem"
//                   }}
//                 >
//                   <CustomVideoToastify />
//                   <button
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       gap: "0.2rem",
//                       border: "1.5px solid #FC350B",
//                       padding: "0rem 1.2rem",
//                       backgroundColor: "white",
//                       borderRadius: "5px",
//                       opacity: "0.9"
//                     }}
//                     onClick={() => {
//                       // your full retake video logic can be plugged back
//                       setVideoCaptured(false);
//                       setBtnType(true);
//                     }}
//                   >
//                     <img src={reload} style={{ width: "1rem", height: "1rem" }} alt="reload" />
//                     <p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FC350B", padding: "0.5rem", cursor: "pointer" }}>
//                       Retake
//                     </p>
//                   </button>
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </>

//       <SnackbarAlert />
//     </div>
//   );
// };

// export default CameraModule2;
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Webcam from "react-webcam";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  Typography
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import FileContext from "../context/Context";
import { SnackbarAlert } from "../custom-component/AlertMessage";
import ImageProgressBar2 from "./ImageProgressBar2";
import CustomToastify from "./custom-notified-msg/CustomToastify";
import CustomVideoToastify from "./custom-notified-msg/CustomVideoToastify";
import VideoTimer from "../video-module/video-timer/VideoTimer";
import Photo_Video_Instruction from "./photo_video_instruction/Photo_Video_Instruction";

import Frame from "../imagesicons/Frame.png";
import "./style.css";
import "./camera.css";

import {
  setAlertMessageSnackbarMessageSeverity,
  setAlertMessageSnackbarMsg,
  setAlertMessageSnackbarOpen
} from "../store/feedback";
import { set_image_upload_status } from "../store/image_upload";
import { useFullscreen } from "../context/FullScreenContext";

const CameraModule2 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { audit_id } = useParams();
  const id = audit_id;

  const { requestFullscreen } = useFullscreen();
  const { latitude, longitude } = useSelector((state) => state.imagesStore);

  const {
    setCapturedImages360,
    setCapturedImageWindshield,
    setCapturedChassisRC,
    setCapturedRegNo,
    setCapturedOdometer,
    setCapturedTyres,
    capturedInspectionImages,
    setCapturedInspectionImages,
    setOdometerVideo
  } = useContext(FileContext);

  const [open, setOpen] = useState(false);
  const [showInstructionPage, setShowInstructionPage] = useState(false);

  const [dialogWidth, setDialogWidth] = useState("29vw");
  const [dialogText, setDialogText] = useState("0.9rem");

  const [btnType, setBtnType] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);

  const [videoCaptured, setVideoCaptured] = useState(false);
  const [imageCaptured, setImageCaptured] = useState(false);

  const [capturedTime, setCapturedTime] = useState(null);
  const [hasRetaken, setHasRetaken] = useState(false);

  const [zoomLevel, setZoomLevel] = useState(1);

  const [image, setImage] = useState(null);
  const webcamRef = useRef(null);

  const timerRef = useRef(31);
  const intervalRef = useRef(null);

  // ✅ prevent multiple API calls per capture
  const hasSavedRef = useRef(false);

  const mediaRecorderRef = useRef(null);
  const recordedChunksRef = useRef([]);

  const reload = require("./Reload.png");

  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  const [isProgressVisible, setIsProgressVisible] = useState(true);

  const storedConfig = localStorage.getItem("inspectionConfiguration");
  const inspectionConfig = storedConfig ? JSON.parse(storedConfig).inspection_config : null;

  // user id
  const insuranceUser = JSON.parse(localStorage.getItem("insuranceUser"));
  const insuranceUserID = JSON.parse(localStorage.getItem("inspectionConfiguration"));
  const userId = insuranceUser?.userId || insuranceUserID?.userID;

  // ✅ capture list
  const imagesToCapture = useMemo(
    () => [
      { viewName: "Face", imageName: "Face", mode: "photo", id: 1 },
      { viewName: "Deceased Body", imageName: "Deceased Body", mode: "photo", id: 2 },
      { viewName: "Ear Tag + Forehead", imageName: "Ear Tag + Forehead", mode: "photo", id: 3 },
      { viewName: "Muzzle 1", imageName: "Muzzle 1", mode: "photo", id: 4 },
      { viewName: "Muzzle 2", imageName: "Muzzle 2", mode: "photo", id: 5 },
      { viewName: "Muzzle 3", imageName: "Muzzle 3", mode: "photo", id: 6 }
    ],
    []
  );

  const mandatoryImages = useMemo(() => {
    return [...imagesToCapture];
  }, [imagesToCapture]);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentImageTitle, setCurrentImageTitle] = useState(mandatoryImages[0] || null);

  useEffect(() => {
    if (!mandatoryImages.length) return;
    setCurrentImageIndex((idx) => (idx < mandatoryImages.length ? idx : 0));
    setCurrentImageTitle((prev) => (prev?.viewName ? prev : mandatoryImages[0]));
  }, [mandatoryImages]);

  // Responsive dialog sizing
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 400) setDialogWidth("85vw");
      else if (window.innerWidth <= 475) setDialogWidth("74vw");
      else if (window.innerWidth <= 575) {
        setDialogText("0.6rem");
        setDialogWidth("64vw");
      } else if (window.innerWidth <= 650) setDialogWidth("60vw");
      else if (window.innerWidth <= 775) setDialogWidth("57vw");
      else if (window.innerWidth <= 875) setDialogWidth("55vw");
      else if (window.innerWidth <= 1000) setDialogWidth("48vw");
      else if (window.innerWidth <= 1100) {
        setDialogWidth("45vw");
        setDialogText("0.8rem");
      } else if (window.innerWidth <= 1300) setDialogWidth("40vw");
      else setDialogWidth("35vw");
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // window dims (camera)
  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Network check guarded
  useEffect(() => {
    const checkNetwork = () => {
      const cur = mandatoryImages[currentImageIndex];
      if (!cur) return;

      if (cur.id >= 15 && cur.id < 18) {
        if (navigator.connection) {
          const { downlink, effectiveType } = navigator.connection;

          if (downlink < 5 || effectiveType === "3g" || effectiveType === "2g") {
            toast.warn("Network is poor", {
              position: "bottom-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
              style: {
                backgroundColor: "#FC350B",
                color: "#fffff",
                width: "auto",
                maxWidth: "300px",
                padding: "10px 20px"
              }
            });
          }
        }
      }
    };

    checkNetwork();
    const interval = setInterval(checkNetwork, 30000);
    return () => clearInterval(interval);
  }, [currentImageIndex, mandatoryImages]);

  // ✅✅✅ ORIENTATION (A)
  const [isLandscape, setIsLandscape] = useState(
    window.matchMedia?.("(orientation: landscape)").matches ??
      window.innerWidth > window.innerHeight
  );

  useEffect(() => {
    const handleOrientation = () => {
      const landscape =
        window.matchMedia?.("(orientation: landscape)").matches ??
        window.innerWidth > window.innerHeight;
      setIsLandscape(landscape);
    };

    window.addEventListener("resize", handleOrientation);
    window.addEventListener("orientationchange", handleOrientation);

    return () => {
      window.removeEventListener("resize", handleOrientation);
      window.removeEventListener("orientationchange", handleOrientation);
    };
  }, []);

  // Webcam constraints: choose camera device
  const [activeDeviceId, setActiveDeviceId] = useState(null);

  const handleDevices = useCallback((mediaDevices) => {
    const videoInputs = mediaDevices.filter((d) => d.kind === "videoinput");
    const preferred = videoInputs.find((d) => d.label.toLowerCase().includes("0"));
    if (preferred) setActiveDeviceId(preferred.deviceId);
  }, []);

  useEffect(() => {
    navigator.mediaDevices?.enumerateDevices?.().then(handleDevices).catch(() => {});
  }, [handleDevices]);

  // ✅✅✅ Dynamic video constraints (B)
  const videoConstraints = useMemo(() => {
    const base = {
      deviceId: activeDeviceId || undefined,
      facingMode: "environment"
    };

    return isLandscape
      ? { ...base, width: { ideal: 1920 }, height: { ideal: 1080 }, aspectRatio: 16 / 9 }
      : { ...base, width: { ideal: 1080 }, height: { ideal: 1920 }, aspectRatio: 9 / 16 };
  }, [activeDeviceId, isLandscape]);

  // Zoom apply
  useEffect(() => {
    const applyZoom = async () => {
      try {
        const stream = webcamRef.current?.video?.srcObject;
        if (!stream) return;
        const track = stream.getVideoTracks()[0];
        if (!track) return;

        const capabilities = track.getCapabilities?.();
        if (capabilities?.zoom) {
          const settings = track.getSettings?.();
          setZoomLevel(settings?.zoom || 1);

          await track.applyConstraints({ advanced: [{ zoom: 1.08 }] });
          setZoomLevel(1.0);
        }
      } catch (error) {
        console.error("Error applying zoom:", error);
      }
    };

    const v = webcamRef.current?.video;
    if (v) v.addEventListener("loadedmetadata", applyZoom);
    return () => {
      if (v) v.removeEventListener("loadedmetadata", applyZoom);
    };
  }, [isLandscape, activeDeviceId]);

  // Lighting analysis
  const [suggestion, setSuggestion] = useState("");
  const [perfectImage, setPerfectImage] = useState(false);

  const analyzeLighting = (imageData) => {
    const { data, width, height } = imageData;
    let totalBrightness = 0;
    for (let i = 0; i < data.length; i += 4) {
      totalBrightness += (data[i] + data[i + 1] + data[i + 2]) / 3;
    }
    const avg = totalBrightness / (width * height);
    if (avg < 100) return "Increase lighting.";
    if (avg > 200) return "Reduce lighting.";
    return "Lighting looks good.";
  };

  const captureAndAnalyze = useCallback(() => {
    const cam = webcamRef.current;
    if (!cam?.getScreenshot) return;

    const imageSrc = cam.getScreenshot();
    if (!imageSrc) return;

    const img = new Image();
    img.src = imageSrc;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0, img.width, img.height);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const lightingSuggestion = analyzeLighting(imageData);
      setSuggestion(lightingSuggestion);
      setPerfectImage(lightingSuggestion === "Lighting looks good.");
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(captureAndAnalyze, 500);
    return () => clearInterval(interval);
  }, [captureAndAnalyze]);

  // Utils
  const azure_image_file_name = (audit, cattleNum, image_name, file_name) => {
    return `${cattleNum}_${image_name}_${file_name}`;
  };

  const base64ToBlob = (base64, contentType = "image/png") => {
    const byteCharacters = atob(base64);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) byteNumbers[i] = slice.charCodeAt(i);
      byteArrays.push(new Uint8Array(byteNumbers));
    }
    return new Blob(byteArrays, { type: contentType });
  };

  const cacheImageBuffer = async (fileName, base64String, clicked_time, name, type, auditId, lat, lng) => {
    try {
      const cache = await caches.open("image-cache");
      const imageBlob = base64ToBlob(base64String, "image/png");

      const metadata = JSON.stringify({
        clicked_time,
        name,
        type,
        id: auditId,
        latitude: lat,
        longitude: lng
      });

      await cache.put(`${fileName}`, new Response(imageBlob, { headers: { "Content-Type": "image/png" } }));
      await cache.put(
        `${fileName}-metadata`,
        new Response(metadata, { headers: { "Content-Type": "application/json" } })
      );
    } catch (error) {
      console.error("Failed to cache image+metadata:", error);
    }
  };

  const upload_image_to_s3 = async (auditId, imgId, clicked_time, lat, lng, fileName, base64String, image_name) => {
    try {
      axios.post("/aiProcessingApis/uploadToTopic", {
        id: imgId,
        auditID: auditId,
        image_name: fileName,
        imageCategory: image_name,
        clicked_time,
        latitude: lat,
        longitude: lng
      });

      if (!base64String || base64String.length < 1000) return;

      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) byteNumbers[i] = byteCharacters.charCodeAt(i);
      const blob = new Blob([new Uint8Array(byteNumbers)], { type: "image/jpeg" });

      const formData = new FormData();
      formData.append("blobName", `Cattle_Insurance_Inspection/auditImages/claimImages/${fileName}`);
      formData.append("file", blob, fileName);
      formData.append("contentType", "image/jpeg");

      const response = await axios.post("/process_data/upload-img", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        maxContentLength: Infinity,
        maxBodyLength: Infinity
      });

      if (response.status === 200) {
        dispatch(set_image_upload_status({ image_name, status: 1, type: "s3_img_upload_status" }));
      }
    } catch (error) {
      console.error("Error uploading image:", error?.message || error);
    }
  };

  const axiosInstance = axios.create({ timeout: 30000 });

  const upload_images_data_db = async (formData, image_name) => {
    try {
      const response = await axiosInstance.post("/process_data/upload_process_store_claim_individually", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (response.status === 200) {
        dispatch(set_image_upload_status({ image_name, status: 1, type: "sql_upload_status" }));
      }
    } catch (error) {
      console.error("DB upload failed:", error);
    }
  };

  // Capture photo
  const capturePhoto = useCallback(() => {
    const cam = webcamRef.current;
    if (!cam?.getScreenshot) return;

    const imageSrc = cam.getScreenshot({ quality: 1 });
    if (!imageSrc) {
      console.warn("imageSrc is null");
      return;
    }

    const formattedCaptureTime = moment().format("YYYY-MM-DD HH:mm:ss");

    const dataURLtoBlob = (dataURL) => {
      if (!dataURL || typeof dataURL !== "string" || !dataURL.startsWith("data:")) return null;
      const parts = dataURL.split(",");
      if (parts.length < 2) return null;

      const byteString = atob(parts[1]);
      const mimeString = parts[0].split(":")[1].split(";")[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
      return new Blob([ab], { type: mimeString });
    };

    const blob = dataURLtoBlob(imageSrc);
    if (!blob) return;

    const file = new File([blob], "captured_image.jpeg", { type: "image/jpeg" });
    hasSavedRef.current = false;
    setImage(file);
    setCapturedTime(formattedCaptureTime);
    setImageCaptured(true);
  }, []);

  // Save + uploads
  const handleSave = useCallback(() => {
    try {
      if (!id) {
        dispatch(setAlertMessageSnackbarMsg("Audit not found !"));
        dispatch(setAlertMessageSnackbarMessageSeverity("error"));
        dispatch(setAlertMessageSnackbarOpen(true));
        setTimeout(() => dispatch(setAlertMessageSnackbarOpen(false)), 5000);
        navigate("/");
        return;
      }

      const currentImage = mandatoryImages[currentImageIndex];
      if (!currentImage) return;
      if (!image) return;

      const res = {
        file: image,
        name: currentImage.imageName,
        clickedTime: capturedTime,
        id: currentImage.id,
        latitude,
        longitude
      };

      if (res.name === "inner_windshield" || res.name === "outer_windshield") setCapturedImageWindshield((p) => [...p, res]);
      else if (res.name === "registrationNo") setCapturedRegNo((p) => [...p, res]);
      else if (res.name === "chassis" || res.name === "RC") setCapturedChassisRC((p) => [...p, res]);
      else if (res.name === "odometer") setCapturedOdometer((p) => [...p, res]);
      else if (["front_left_tyre", "back_left_tyre", "back_right_tyre", "front_right_tyre"].includes(res.name)) setCapturedTyres((p) => [...p, res]);
      else setCapturedImages360((p) => [...p, res]);

      setCapturedInspectionImages((prev) => {
        const filtered = prev.filter((x) => x.id !== res.id);
        return [...filtered, res];
      });

      const cattleNum = localStorage.getItem("cattle num") || "cattle";
      const fileName = azure_image_file_name(id, cattleNum, res.name, res.file.name);

      const reader = new FileReader();
      reader.onloadend = () => {
        const dataUrl = reader.result;
        const base64String = String(dataUrl).split(",")[1];

        cacheImageBuffer(fileName, base64String, res.clickedTime, res.name, res.id, id, latitude, longitude);

        upload_image_to_s3(id, res.id, res.clickedTime, latitude, longitude, fileName, base64String, res.name);

        const formData = new FormData();
        formData.append("clickedTime", res.clickedTime);
        formData.append("name", res.name);
        formData.append("id", res.id);
        formData.append("auditID", id);
        formData.append("latitude", latitude);
        formData.append("longitude", longitude);
        formData.append("azure_image_name", fileName);
        formData.append("cattlenumber", id);
        formData.append("type", res.id);

        upload_images_data_db(formData, res.name);
      };

      reader.readAsDataURL(image);
    } catch (e) {
      console.error("handleSave crashed:", e);
    }
  }, [
    id,
    dispatch,
    navigate,
    mandatoryImages,
    currentImageIndex,
    image,
    capturedTime,
    latitude,
    longitude,
    setCapturedInspectionImages,
    setCapturedImages360,
    setCapturedImageWindshield,
    setCapturedChassisRC,
    setCapturedRegNo,
    setCapturedOdometer,
    setCapturedTyres
  ]);

  // After capture -> auto save -> advance
  useEffect(() => {
    if ((imageCaptured || videoCaptured) && !hasRetaken) {
      if (imageCaptured && !hasSavedRef.current) {
        hasSavedRef.current = true;
        handleSave();
      }

      const timer = setTimeout(() => {
        const nextIndex = currentImageIndex + 1;

        if (nextIndex < mandatoryImages.length) {
          setCurrentImageIndex(nextIndex);
          setCurrentImageTitle(mandatoryImages[nextIndex]);
          setShowInstructionPage(mandatoryImages[nextIndex]?.viewName === "RPM Meter Video");
        }

        setImageCaptured(false);
        setVideoCaptured(false);
      }, 6000);

      return () => clearTimeout(timer);
    }
  }, [hasRetaken, imageCaptured, videoCaptured, handleSave, currentImageIndex, mandatoryImages]);

  // Completion navigate
  useEffect(() => {
    if (capturedInspectionImages.length === mandatoryImages.length && mandatoryImages.length > 0) {
      const timer = setTimeout(() => {
        navigate("/auditList", { state: { activeTab: "claim" } });
      }, 6000);

      return () => clearTimeout(timer);
    }
  }, [capturedInspectionImages, mandatoryImages, id, navigate]);

  // Inactivity timer
  useEffect(() => {
    const checkInactivityTimeout = () => {
      const now = Date.now();
      const last = sessionStorage.getItem("lastPhotoTimestamp");
      if (last && now - parseInt(last, 10) > 14 * 60 * 1000) {
        sessionStorage.removeItem("lastPhotoTimestamp");
        dispatch(setAlertMessageSnackbarMsg("15-minute inactivity detected. Restarting inspection."));
        dispatch(setAlertMessageSnackbarMessageSeverity("warning"));
        dispatch(setAlertMessageSnackbarOpen(true));
        navigate(-1);
      }
    };

    const interval = setInterval(checkInactivityTimeout, 60000);
    return () => clearInterval(interval);
  }, [dispatch, navigate]);

  // instruction text
  const getInstructionText = (viewName) => {
    const map = {
      Face: "Take photo of the Face of the animal",
      "Deceased Body": "Take photo of Deceased Body of the animal",
      "Ear Tag + Forehead": "Take photo of eartag with the forehead of the animal",
      "Muzzle 1": "Take photo of muzzle view 1 of the animal",
      "Muzzle 2": "Take photo of muzzle view 2 of the animal",
      "Muzzle 3": "Take photo of muzzle view 3 of the animal"
    };

    if (!viewName) return "Loading...";
    return map[viewName] || `Take photo of the ${viewName.toLowerCase()} of the animal`;
  };

  const handleFullscreenRequest = () => {
    requestFullscreen();
    setOpen(false);
  };

  const handleCloseDialog = (event) => {
    if (event.target.tagName.toLowerCase() !== "button" && !event.target.closest("button")) return;
    setOpen(false);
  };

  const handleRetakeClick = () => {
    setHasRetaken(true);
    setImageCaptured(false);
    setVideoCaptured(false);

    setCapturedInspectionImages((prev) => {
      if (!prev.length) return [];
      return prev.slice(0, -1);
    });

    setTimeout(() => setHasRetaken(false), 50);
  };

  // Video capture
  const [capturing, setCapturing] = useState(false);

  const handleStartCaptureClick = useCallback(() => {
    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), 10000);

    setBtnType(false);
    setCapturing(true);

    recordedChunksRef.current = [];
    clearInterval(intervalRef.current);
    timerRef.current = 31;

    const stream = webcamRef.current?.video?.srcObject;
    if (!stream) return;

    let mimeType = "video/webm";
    if (MediaRecorder.isTypeSupported("video/mp4;codecs=avc1")) mimeType = "video/mp4;codecs=avc1";
    else if (MediaRecorder.isTypeSupported("video/webm;codecs=vp9")) mimeType = "video/webm;codecs=vp9";
    else if (MediaRecorder.isTypeSupported("video/webm;codecs=vp8")) mimeType = "video/webm;codecs=vp8";

    const options = { mimeType, videoBitsPerSecond: 5000000, audioBitsPerSecond: 256000 };

    if (!userId || userId === "UID101" || userId === "USR_291628" || userId === "USR_542794") {
      delete options.audioBitsPerSecond;
      stream.getAudioTracks().forEach((t) => t.stop());
    }

    const handleDataAvailable = ({ data }) => {
      if (data.size > 0) {
        recordedChunksRef.current.push(data);
        if (currentImageTitle?.imageName === "rpm_meter_video") {
          setOdometerVideo(recordedChunksRef.current);
        }
      }
    };

    try {
      mediaRecorderRef.current = new MediaRecorder(stream, options);
      mediaRecorderRef.current.addEventListener("dataavailable", handleDataAvailable);

      intervalRef.current = setInterval(() => {
        if (timerRef.current > 0) {
          timerRef.current -= 1;
          setCapturing((p) => !p);
        }
      }, 1000);

      mediaRecorderRef.current.start();
    } catch (e) {
      console.error("MediaRecorder start failed:", e);
    }
  }, [userId, currentImageTitle, setOdometerVideo]);

  const handleStopCaptureClick = useCallback(() => {
    setBtnType(true);
    setVideoCaptured(true);

    try {
      mediaRecorderRef.current?.stop?.();
    } catch (e) {}

    setCapturing(false);
    clearInterval(intervalRef.current);
    timerRef.current = 31;
  }, []);

  useEffect(() => {
    if (timerRef.current <= 0) handleStopCaptureClick();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [capturing]);

  const buttonStyle = {
    display: "flex",
    cursor: "pointer",
    alignItems: "center",
    justifyContent: "center",
    width: "72px",
    height: "72px",
    backgroundColor: "transparent",
    borderRadius: "50%",
    border: perfectImage ? "4px solid #4CAF50" : "4px solid white",
    padding: "1px"
  };

  const innerCircleStyle = {
    width: "55px",
    height: "55px",
    backgroundColor: "white",
    borderRadius: "50%"
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes < 10 ? "0" : ""}${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  // instruction icon auto-hide
  const [isIconVisible, setIsIconVisible] = useState(true);
  useEffect(() => {
    setIsIconVisible(true);
    const t = setTimeout(() => setIsIconVisible(false), 18000);
    return () => clearTimeout(t);
  }, [currentImageTitle]);

  // If audit missing
  useEffect(() => {
    if (!id) navigate("/");
  }, [id, navigate]);

  // last photo timestamp
  useEffect(() => {
    if (imageCaptured) sessionStorage.setItem("lastPhotoTimestamp", Date.now().toString());
  }, [imageCaptured]);

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        className="full_screen_class"
        PaperProps={{
          style: {
            width: dialogWidth,
            padding: "0.5rem 0.5rem",
            paddingBottom: "0.5rem",
            borderRadius: "4px",
            margin: "0"
          }
        }}
      >
        <DialogContent sx={{ padding: "0.2rem 0.3rem" }}>
          <DialogTitle style={{ fontSize: dialogText, color: "black", padding: "0.4rem 0", fontWeight: "600" }}>
            Full Screen Mode ?
          </DialogTitle>
          <DialogContentText sx={{ color: "black", fontSize: "0.8rem" }}>
            Switch to full screen mode.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "0.4rem" }}>
          <div style={{ padding: "0.1rem" }}>
            <button
              onClick={handleFullscreenRequest}
              style={{
                color: "white",
                backgroundColor: "#FC350B",
                border: "none",
                padding: "0.4rem 0.8rem",
                textTransform: "capitalize",
                borderRadius: "20px",
                cursor: "pointer"
              }}
            >
              Switch
            </button>
          </div>
        </DialogActions>
      </Dialog>

      <>
        {showInstructionPage ? (
          <Photo_Video_Instruction setShowInstructionPage={setShowInstructionPage} />
        ) : (
          <>
            {/* TOP LEFT INSTRUCTION */}
        <Typography
  sx={{
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "6px 10px",
    position: "absolute",
    left: "12px",
    top: "calc(env(safe-area-inset-top) + 5px)", // ✅ tight to top
    background: "#CAC2C2CC",
    borderRadius: "8px",
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "150%",
    textAlign: "center",
    color: "black",
    zIndex: 3000,
    "@media (max-width: 900px) and (orientation: landscape)": {
      fontSize: "14px",
      fontWeight: 700
      // ❌ removed top: 70px
    }
  }}
>
              {getInstructionText(currentImageTitle?.viewName)}
            </Typography>

            {/* TOP RIGHT: PROGRESS + TOGGLE */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                position: "fixed",
                top: "12px",
                right: "12px",
                zIndex: 3000,
                gap: "6px"
              }}
            >
              {isProgressVisible && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "8px",
                    gap: "10px",
                    width: "20vw",
                    height: "38px",
                    background: "#FFFFFF99",
                    borderRadius: "8px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                  }}
                >
                  <ImageProgressBar2 />
                </Box>
              )}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "40px",
                  height: "40px",
                  background: "#FFFFFF",
                  borderRadius: "8px",
                  cursor: "pointer",
                  pointerEvents: "auto",
                  "&:hover": { background: "#FFFFFFCC" }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsProgressVisible(!isProgressVisible);
                }}
              >
                <img
                  src={Frame}
                  alt="Toggle Progress Bar"
                  style={{ width: "39px", height: "59px", objectFit: "contain" }}
                />
              </Box>
            </Box>

            {/* LIGHTING SUGGESTION */}
            {suggestion && !imageCaptured && !videoCaptured && (
              <Typography
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "8px 8px",
                  gap: "8px",
                  position: "absolute",
                  width: "auto",
                  height: "33px",
                  left: "10px",
                  bottom: "30px",
                  background: "rgba(255, 255, 255, 0.6)",
                  borderRadius: "8px",
                  fontFamily: "'Montserrat', sans-serif",
                  fontWeight: 500,
                  fontSize: "13px",
                  lineHeight: "157%",
                  textAlign: "center",
                  letterSpacing: "0.1px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  color: "black",
                  zIndex: 2500
                }}
              >
                {suggestion}
              </Typography>
            )}

            {/* ✅✅✅ CAMERA VIEW (C) - fullscreen without hiding overlays */}
            <div
              className="image-page"
              style={{
                width: "100vw",
                height: "100dvh",
                display: imageCaptured || videoCaptured ? "none" : "flex",
                position: "relative"
              }}
            >
              <div
                className="webcam-container"
                style={{
                  width: "100vw",
                  height: "100dvh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "black",
                  overflow: "hidden",
                  position: "relative"
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "5px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 10,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: "5px",
                    height: "20px",
                    fontSize: "0.8rem",
                    display: "flex",
                    alignItems: "center"
                  }}
                >
                  {`Zoom: ${zoomLevel}x`}
                </div>

                <Webcam
                  audio={!!userId && userId !== "UID101" && userId !== "USR_291628" && userId !== "USR_542794"}
                  muted={true}
                  mirrored={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  screenshotQuality={1}
                  videoConstraints={videoConstraints} // ✅ A+B applied
                  className="webcam"
                  style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover", // ✅ fill screen in landscape (may crop edges)
                    backgroundColor: "black",
                    zIndex: 1
                  }}
                />
              </div>

              <ToastContainer />

              {/* TIMER (for video) */}
              <div
                style={{
                  position: "absolute",
                  right: "50%",
                  top: "50%",
                  transform: "translate(50%, -50%)",
                  zIndex: 3500,
                  color: "white",
                  fontSize: "1.5rem"
                }}
              >
                {timerRef.current - 1 <= 5 && <VideoTimer number={timerRef.current - 1} />}
              </div>

              {!btnType && (
                <Typography
                  sx={{
                    position: "absolute",
                    right: "15px",
                    top: "100px",
                    background: "rgba(255, 255, 255, 0.6)",
                    borderRadius: "8px",
                    padding: "8px",
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "black",
                    zIndex: 3000
                  }}
                >
                  {formatTime(timerRef.current - 1)}
                </Typography>
              )}

              {/* CAPTURE BUTTON */}
              <div
                style={{
                  position: "fixed",
                  bottom: "139px",
                  right: "15px",
                  zIndex: 4000
                }}
              >
                {!currentImageTitle?.mode || currentImageTitle?.mode === "photo" ? (
                  <button style={buttonStyle} onClick={capturePhoto}>
                    <div style={innerCircleStyle} />
                  </button>
                ) : (
                  <div
                    style={{
                      ...buttonStyle,
                      opacity: isDisabled ? 0.5 : 1,
                      pointerEvents: isDisabled ? "none" : "auto",
                      cursor: isDisabled ? "not-allowed" : "pointer"
                    }}
                    onClick={!isDisabled && (btnType ? handleStartCaptureClick : handleStopCaptureClick)}
                  >
                    <div style={{ ...innerCircleStyle, backgroundColor: btnType ? "green" : "#F44336" }} />
                  </div>
                )}
              </div>
            </div>

            {/* AFTER PHOTO CAPTURE */}
            {imageCaptured && (
              <div
                style={{
                  width: "100vw",
                  height: "100dvh",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "black"
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "60%",
                    transform: "translateY(-50%)",
                    display: "flex",
                    flexDirection: "column",
                    alignContent: "center",
                    justifyContent: "center",
                    gap: "6rem"
                  }}
                >
                  <CustomToastify />
                  <button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "0.2rem",
                      border: "1.5px solid #FC350B",
                      padding: "0rem 1.2rem",
                      backgroundColor: "white",
                      borderRadius: "5px",
                      opacity: "0.9"
                    }}
                  >
                    <img src={reload} style={{ width: "1rem", height: "1rem" }} alt="reload" />
                    <p
                      style={{
                        fontSize: "1rem",
                        fontFamily: "'Montserrat', sans-serif",
                        color: "#FC350B",
                        padding: "0.5rem",
                        cursor: "pointer"
                      }}
                      onClick={handleRetakeClick}
                    >
                      Retake
                    </p>
                  </button>
                </div>

                {image && (
                  <img
                    src={URL.createObjectURL(image)}
                    alt="Captured"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                )}
              </div>
            )}

            {/* AFTER VIDEO CAPTURE */}
            {videoCaptured && (
              <div
                style={{
                  width: "100vw",
                  height: "100dvh",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "black"
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "60%",
                    transform: "translateY(-50%)",
                    display: "flex",
                    flexDirection: "column",
                    alignContent: "center",
                    justifyContent: "center",
                    gap: "6rem"
                  }}
                >
                  <CustomVideoToastify />
                  <button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "0.2rem",
                      border: "1.5px solid #FC350B",
                      padding: "0rem 1.2rem",
                      backgroundColor: "white",
                      borderRadius: "5px",
                      opacity: "0.9"
                    }}
                    onClick={() => {
                      setVideoCaptured(false);
                      setBtnType(true);
                    }}
                  >
                    <img src={reload} style={{ width: "1rem", height: "1rem" }} alt="reload" />
                    <p
                      style={{
                        fontSize: "1rem",
                        fontFamily: "'Montserrat', sans-serif",
                        color: "#FC350B",
                        padding: "0.5rem",
                        cursor: "pointer"
                      }}
                    >
                      Retake
                    </p>
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </>

      <SnackbarAlert />
    </div>
  );
};

export default CameraModule2;